import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSON: any;
  JSONObject: any;
};

export enum AccountType {
  Main = 'MAIN',
  Sub = 'SUB'
}

export enum AceCoinTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Payment = 'PAYMENT',
  Purchase = 'PURCHASE',
  Transfer = 'TRANSFER'
}

export type Admin = SystemUser & {
  __typename?: 'Admin';
  authorizedClubhouses?: Maybe<Array<Maybe<Scalars['String']>>>;
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  permissions: Array<Maybe<Scalars['String']>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminActivateMembership = {
  __typename?: 'AdminActivateMembership';
  payment?: Maybe<HitPayPaymentRequest>;
};

export type AdminActivateMembershipInput = {
  membershipUuid: Scalars['String'];
  paymentOption: AdminCreateMembershipPaymentOption;
  paymentRef?: InputMaybe<Scalars['String']>;
};

export type AdminArgs = {
  userId: Scalars['String'];
};

export type AdminAuthResponse = {
  __typename?: 'AdminAuthResponse';
  accessToken: Scalars['String'];
  authenticatedAdmin: AuthenticatedAdmin;
};

export type AdminBasic = {
  __typename?: 'AdminBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type AdminBooking = {
  __typename?: 'AdminBooking';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationNotificationByAppSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationByEmailSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationBySmsSent?: Maybe<Scalars['Boolean']>;
  cancellationNotificationMessage?: Maybe<Scalars['String']>;
  cancellationNotificationSentBy?: Maybe<SentBy>;
  cancellationNotificationSentByAdminId?: Maybe<Scalars['String']>;
  cancellationNotificationSentByAdminName?: Maybe<Scalars['String']>;
  cancellationNotificationSentDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  cancelledByAdminName?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  coachName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CreatedBy>;
  createdByAdminName?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  endTime: Scalars['DateTime'];
  fieldLessonDetails?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<GameCourseType>;
  id: Scalars['String'];
  member: Scalars['String'];
  memberIndividualId: Scalars['String'];
  memberUuid: Scalars['String'];
  noOfPlayers: Scalars['Int'];
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
};

export type AdminBookingArgs = {
  bookingId: Scalars['String'];
};

export type AdminBookingAvailabilityArgs = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  date: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  durationType?: InputMaybe<DurationType>;
  facilityType?: InputMaybe<FacilityType>;
};

export type AdminBookingBasic = {
  __typename?: 'AdminBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  member: AdminBookingBasicMember;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
};

export type AdminBookingBasicMember = {
  __typename?: 'AdminBookingBasicMember';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminBookingCancelInput = {
  bookingId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
};

export type AdminBookingEdge = {
  __typename?: 'AdminBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBookingBasic>;
};

export type AdminBookingResponse = {
  __typename?: 'AdminBookingResponse';
  edges?: Maybe<Array<Maybe<AdminBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminBookingSendCancellationNotificationInput = {
  bookingId: Scalars['String'];
  notificationMessage?: InputMaybe<Scalars['String']>;
  notifyByApp: Scalars['Boolean'];
  notifyByEmail: Scalars['Boolean'];
  notifyBySms: Scalars['Boolean'];
};

export type AdminBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
};

export type AdminClientLoginGuestInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  nickName: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClientSetupInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
};

export type AdminClientStatusArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminClubhouse = {
  __typename?: 'AdminClubhouse';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressCountryIso?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  baySimulators: Array<Maybe<BaySimulator>>;
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseId: Scalars['String'];
  colorCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  day0EndTime?: Maybe<Scalars['Int']>;
  day0StartTime?: Maybe<Scalars['Int']>;
  day1EndTime?: Maybe<Scalars['Int']>;
  day1StartTime?: Maybe<Scalars['Int']>;
  day2EndTime?: Maybe<Scalars['Int']>;
  day2StartTime?: Maybe<Scalars['Int']>;
  day3EndTime?: Maybe<Scalars['Int']>;
  day3StartTime?: Maybe<Scalars['Int']>;
  day4EndTime?: Maybe<Scalars['Int']>;
  day4StartTime?: Maybe<Scalars['Int']>;
  day5EndTime?: Maybe<Scalars['Int']>;
  day5StartTime?: Maybe<Scalars['Int']>;
  day6EndTime?: Maybe<Scalars['Int']>;
  day6StartTime?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  kGolfClientId?: Maybe<Scalars['String']>;
  kGolfClientSecret?: Maybe<Scalars['String']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfShopGuid?: Maybe<Scalars['String']>;
  kGolfUsername?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfPrivateRooms?: Maybe<Scalars['Int']>;
  noOfPuttingGreen?: Maybe<Scalars['Int']>;
  noOfSimulators?: Maybe<Scalars['Int']>;
  organization: ClubhouseOrganization;
  organizationId: Scalars['String'];
  overrides: Array<Maybe<ClubhouseOverride>>;
  phoneNumber?: Maybe<Scalars['String']>;
  privateRooms: Array<Maybe<PrivateRoom>>;
  puttingGreens: Array<Maybe<PuttingGreen>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminClubhouseArgs = {
  clubhouseId: Scalars['String'];
};

export type AdminClubhouseBasic = {
  __typename?: 'AdminClubhouseBasic';
  clubhouseCode: Scalars['String'];
  clubhouseId: Scalars['String'];
  name: Scalars['String'];
};

export type AdminClubhouseEdge = {
  __typename?: 'AdminClubhouseEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminClubhouseBasic>;
};

export type AdminClubhouseFacilitiesArgs = {
  shopGuid: Scalars['String'];
};

export type AdminClubhouseResponse = {
  __typename?: 'AdminClubhouseResponse';
  edges?: Maybe<Array<Maybe<AdminClubhouseEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminClubhousesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCoachBasic = {
  __typename?: 'AdminCoachBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
};

export type AdminCoachEdge = {
  __typename?: 'AdminCoachEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminCoachBasic>;
};

export type AdminCoachResponse = {
  __typename?: 'AdminCoachResponse';
  edges?: Maybe<Array<Maybe<AdminCoachEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminCoachesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminCreateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
  userType?: InputMaybe<UserType>;
};

export type AdminCreateMembershipInput = {
  clubhouseCode?: InputMaybe<Scalars['String']>;
  companyContactPersonDesignation?: InputMaybe<Scalars['String']>;
  companyContactPersonEmail?: InputMaybe<Scalars['String']>;
  companyContactPersonFirstName?: InputMaybe<Scalars['String']>;
  companyContactPersonLastName?: InputMaybe<Scalars['String']>;
  companyIndustry?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  mainMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
  membershipSlug: Scalars['String'];
  paymentOption: AdminCreateMembershipPaymentOption;
  paymentRef?: InputMaybe<Scalars['String']>;
  reservedId?: InputMaybe<Scalars['String']>;
  subMembers?: InputMaybe<Array<InputMaybe<CreateMemberInput>>>;
};

export enum AdminCreateMembershipPaymentOption {
  BankTransfer = 'BANK_TRANSFER',
  Hitpay = 'HITPAY',
  Later = 'LATER',
  Na = 'NA'
}

export type AdminCreditTransactionEdge = {
  __typename?: 'AdminCreditTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CreditTransaction>;
};

export type AdminCreditTransactionResponse = {
  __typename?: 'AdminCreditTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminCreditTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminDeleteAdminInput = {
  userId: Scalars['String'];
};

export type AdminDeleteCoachInput = {
  userId: Scalars['String'];
};

export type AdminDeleteMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminEdge = {
  __typename?: 'AdminEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminBasic>;
};

export type AdminExtendClientTimeInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
  timeInSeconds: Scalars['Int'];
};

export type AdminForgotPasswordInput = {
  email: Scalars['String'];
};

export type AdminForgotPasswordResponse = {
  __typename?: 'AdminForgotPasswordResponse';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type AdminForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type AdminGameHistory = {
  __typename?: 'AdminGameHistory';
  currentPage: Scalars['Int'];
  list: Array<Maybe<AdminGameHistoryListItem>>;
  maxPage: Scalars['Int'];
  totalCount: Scalars['Int'];
};

export type AdminGameHistoryArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  bays?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  gameTypeField?: InputMaybe<Scalars['Boolean']>;
  gameTypeFourSome?: InputMaybe<Scalars['Boolean']>;
  gameTypePutting?: InputMaybe<Scalars['Boolean']>;
  gameTypeShot?: InputMaybe<Scalars['Boolean']>;
  gameTypeShotContest?: InputMaybe<Scalars['Boolean']>;
  gameTypeStroke?: InputMaybe<Scalars['Boolean']>;
  nickName?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type AdminGameHistoryListItem = {
  __typename?: 'AdminGameHistoryListItem';
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  endTime?: Maybe<Scalars['Float']>;
  gameRoundId: Scalars['Int'];
  gameType: Scalars['String'];
  gameTypeCode: Scalars['Int'];
  playerCount: Scalars['Int'];
  startTime: Scalars['Float'];
};

export type AdminGameRoundScoreCard = {
  __typename?: 'AdminGameRoundScoreCard';
  gameRoundInfo: GameRoundGameInfo;
  players: Array<Maybe<GameRoundPlayerInfo>>;
};

export type AdminJwtAccessToken = {
  __typename?: 'AdminJwtAccessToken';
  adminName?: Maybe<Scalars['String']>;
  baseCountryCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  ud?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminJwtRefreshToken = {
  __typename?: 'AdminJwtRefreshToken';
  adminName?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type AdminKGolfMember = {
  __typename?: 'AdminKGolfMember';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  connectKakao?: Maybe<Scalars['Boolean']>;
  connectWechat?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  handed?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  isTermsAgreeNotificationEmail?: Maybe<Scalars['Boolean']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminKGolfMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminLessonVoucherEdge = {
  __typename?: 'AdminLessonVoucherEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LessonVoucher>;
};

export type AdminLessonVoucherResponse = {
  __typename?: 'AdminLessonVoucherResponse';
  edges?: Maybe<Array<Maybe<AdminLessonVoucherEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminLessonVouchersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminLockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AdminMember = {
  __typename?: 'AdminMember';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  birthday: Scalars['String'];
  credit: Scalars['Float'];
  creditSpent: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  hasSubscriptions: Scalars['Boolean'];
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  locker: Scalars['Boolean'];
  mainId: Scalars['String'];
  memberStatus: MemberStatus;
  memberUuid: Scalars['String'];
  membershipStatus: MembershipStatus;
  membershipType?: Maybe<MembershipTypeBasic>;
  membershipUuid: Scalars['String'];
  mobileNumber: Scalars['String'];
  nickname?: Maybe<Scalars['String']>;
  partialNricOrFin: Scalars['String'];
  profileImageUrl: Scalars['String'];
  signUpSidasInsoles: Scalars['Int'];
  voucherField: Scalars['Int'];
  voucherIndoor: Scalars['Int'];
};

export type AdminMemberArgs = {
  memberUuid: Scalars['String'];
};

export type AdminMemberEdge = {
  __typename?: 'AdminMemberEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberBasic>;
};

export type AdminMemberResponse = {
  __typename?: 'AdminMemberResponse';
  edges?: Maybe<Array<Maybe<AdminMemberEdge>>>;
  pageInfo?: Maybe<AdminMemberResponsePageInfo>;
};

export type AdminMemberResponsePageInfo = {
  __typename?: 'AdminMemberResponsePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  failedKGolfAccounts?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type AdminMemberSubscriptionEdge = {
  __typename?: 'AdminMemberSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscription>;
};

export type AdminMemberSubscriptionResponse = {
  __typename?: 'AdminMemberSubscriptionResponse';
  balance?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  daysLeft?: Maybe<Scalars['Int']>;
  edges?: Maybe<Array<Maybe<AdminMemberSubscriptionEdge>>>;
  endDate?: Maybe<Scalars['DateTime']>;
  mainMemberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  membershipUuid?: Maybe<Scalars['String']>;
  pageInfo?: Maybe<PageInfo>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SubscriptionStatus>;
};

export type AdminMemberSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuid: Scalars['String'];
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMembershipSubscription = {
  __typename?: 'AdminMembershipSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminMembershipSubscriptionBasic = {
  __typename?: 'AdminMembershipSubscriptionBasic';
  credit: Scalars['Float'];
  endDate: Scalars['DateTime'];
  mainMemberMainId: Scalars['String'];
  mainMemberName: Scalars['String'];
  membershipUuid: Scalars['String'];
  status?: Maybe<SubscriptionStatus>;
};

export type AdminMembershipSubscriptionEdge = {
  __typename?: 'AdminMembershipSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminMembershipSubscriptionBasic>;
};

export type AdminMembershipSubscriptionResponse = {
  __typename?: 'AdminMembershipSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminMembershipSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminMembershipSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdminMembershipType = {
  __typename?: 'AdminMembershipType';
  baseCountryCode?: Maybe<CountryCode>;
  compDailySimulatorUse?: Maybe<Scalars['Int']>;
  compDailySimulatorUseType?: Maybe<CompDailySimulatorUseType>;
  compFieldLessons?: Maybe<Scalars['Int']>;
  compIndoorLessons?: Maybe<Scalars['Int']>;
  compLocker?: Maybe<Scalars['Boolean']>;
  designatedPrivateRoom?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  initialCredits?: Maybe<Scalars['Int']>;
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  loungeAccess?: Maybe<Scalars['Boolean']>;
  mainTypeSlug?: Maybe<Scalars['String']>;
  monthlySub?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  publicName?: Maybe<Scalars['String']>;
  signupProductSidasInsoles?: Maybe<Scalars['Boolean']>;
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypeArgs = {
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminMembershipTypeBasic = {
  __typename?: 'AdminMembershipTypeBasic';
  baseCountryCode?: Maybe<CountryCode>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  tier?: Maybe<MembershipTypeTier>;
  versionSlug?: Maybe<Scalars['String']>;
};

export type AdminMembershipTypes = {
  __typename?: 'AdminMembershipTypes';
  lifestyle?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  numberOfTypes?: Maybe<Scalars['Int']>;
  premium?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
  vip?: Maybe<Array<Maybe<AdminMembershipTypeBasic>>>;
};

export type AdminMembershipTypesArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminNewMembership = {
  __typename?: 'AdminNewMembership';
  fileUploadCredentials?: Maybe<AdminNewMembershipFileUploadCredentials>;
  memberUuid?: Maybe<Scalars['String']>;
  payment?: Maybe<HitPayPaymentRequest>;
};

export type AdminNewMembershipFileUploadCredentials = {
  __typename?: 'AdminNewMembershipFileUploadCredentials';
  mainMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
  subMembers?: Maybe<Array<Maybe<FileUploadObject>>>;
};

export type AdminOrganization = {
  __typename?: 'AdminOrganization';
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<BasicClubhouseDetails>>>;
  id: Scalars['String'];
};

export type AdminPaySubscriptionsInput = {
  membershipUuid: Scalars['String'];
};

export type AdminReportCreditTransaction = {
  __typename?: 'AdminReportCreditTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  member?: Maybe<AdminReportCreditTransactionMember>;
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  type?: Maybe<AceCoinTransactionType>;
};

export type AdminReportCreditTransactionEdge = {
  __typename?: 'AdminReportCreditTransactionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportCreditTransaction>;
};

export type AdminReportCreditTransactionMember = {
  __typename?: 'AdminReportCreditTransactionMember';
  firstName?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminReportCreditTransactionResponse = {
  __typename?: 'AdminReportCreditTransactionResponse';
  edges?: Maybe<Array<Maybe<AdminReportCreditTransactionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportCreditTransactionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportLessonVoucher = {
  __typename?: 'AdminReportLessonVoucher';
  amount?: Maybe<Scalars['Int']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  member?: Maybe<AdminReportLessonVoucherMember>;
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<LessonVoucherTransactionType>;
  type?: Maybe<LessonVoucherType>;
  venue?: Maybe<Scalars['String']>;
};

export type AdminReportLessonVoucherEdge = {
  __typename?: 'AdminReportLessonVoucherEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportLessonVoucher>;
};

export type AdminReportLessonVoucherMember = {
  __typename?: 'AdminReportLessonVoucherMember';
  firstName?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AdminReportLessonVoucherResponse = {
  __typename?: 'AdminReportLessonVoucherResponse';
  edges?: Maybe<Array<Maybe<AdminReportLessonVoucherEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportLessonVouchersArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportMemberStat = {
  __typename?: 'AdminReportMemberStat';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  stat?: Maybe<Scalars['Float']>;
};

export type AdminReportMemberStatEdge = {
  __typename?: 'AdminReportMemberStatEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportMemberStat>;
};

export type AdminReportMemberStatResponse = {
  __typename?: 'AdminReportMemberStatResponse';
  edges?: Maybe<Array<Maybe<AdminReportMemberStatEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export enum AdminReportMemberStatType {
  CreditTransactionCount = 'CREDIT_TRANSACTION_COUNT',
  LessonRedemptionCount = 'LESSON_REDEMPTION_COUNT',
  OrderCount = 'ORDER_COUNT',
  SubscriptionCount = 'SUBSCRIPTION_COUNT'
}

export type AdminReportMemberStatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Direction>;
  statType: AdminReportMemberStatType;
};

export type AdminReportOrderArgs = {
  orderNo: Scalars['String'];
};

export type AdminReportOrderEdge = {
  __typename?: 'AdminReportOrderEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OrderBasic>;
};

export type AdminReportOrderPageInfo = {
  __typename?: 'AdminReportOrderPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  noOfNonConnectedOrders?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type AdminReportOrderResponse = {
  __typename?: 'AdminReportOrderResponse';
  edges?: Maybe<Array<Maybe<AdminReportOrderEdge>>>;
  pageInfo?: Maybe<AdminReportOrderPageInfo>;
};

export type AdminReportOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  memberUuidFilter?: InputMaybe<Scalars['String']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  nonConnectedFilter?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportSubscription = {
  __typename?: 'AdminReportSubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AdminReportSubscriptionEdge = {
  __typename?: 'AdminReportSubscriptionEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminReportSubscription>;
};

export type AdminReportSubscriptionResponse = {
  __typename?: 'AdminReportSubscriptionResponse';
  edges?: Maybe<Array<Maybe<AdminReportSubscriptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminReportSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  membershipUuidFilter?: InputMaybe<Scalars['String']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminReportUpdateOrderConnectionInput = {
  memberUuid?: InputMaybe<Scalars['String']>;
  membershipUuid?: InputMaybe<Scalars['String']>;
  nonMemberCustomer?: InputMaybe<Scalars['Boolean']>;
  orderNo: Scalars['String'];
};

export type AdminResendOnboardingEmailInput = {
  userId: Scalars['String'];
};

export type AdminReservedId = {
  __typename?: 'AdminReservedId';
  id?: Maybe<Scalars['Int']>;
  membershipId?: Maybe<Scalars['String']>;
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  onHoldFor?: Maybe<Scalars['String']>;
  status?: Maybe<ReservedIdStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminReservedIds = {
  __typename?: 'AdminReservedIds';
  idOnHold?: Maybe<Scalars['String']>;
  idOnHoldExpiresAt?: Maybe<Scalars['DateTime']>;
  reservedIds?: Maybe<Array<Maybe<AdminReservedId>>>;
};

export type AdminReservedIdsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminResponse = {
  __typename?: 'AdminResponse';
  edges?: Maybe<Array<Maybe<AdminEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminScoreCard = {
  __typename?: 'AdminScoreCard';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<AdminGameRoundScoreCard>>;
};

export type AdminScoreCardArgs = {
  accessToken: Scalars['String'];
  gameRoundId: Scalars['Int'];
};

export type AdminShopDetails = {
  __typename?: 'AdminShopDetails';
  CDN?: Maybe<Scalars['String']>;
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  clientType?: Maybe<AdminShopDetailsClientType>;
  country?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  isEquipmentStorage?: Maybe<Scalars['Boolean']>;
  isLeftHanded?: Maybe<Scalars['Boolean']>;
  isParking?: Maybe<Scalars['Boolean']>;
  isProLesson?: Maybe<Scalars['Boolean']>;
  isShopCloseNextDay?: Maybe<Scalars['Boolean']>;
  isSwingplate?: Maybe<Scalars['Boolean']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerMobilePhone?: Maybe<Scalars['String']>;
  ownerMobilePhoneCountry?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  shopCloseTime?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  shopOpenTime?: Maybe<Scalars['String']>;
  shopPhone?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type AdminShopDetailsArg = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopDetailsClientType = {
  __typename?: 'AdminShopDetailsClientType';
  lesson?: Maybe<Scalars['Boolean']>;
  practice?: Maybe<Scalars['Boolean']>;
  screen?: Maybe<Scalars['Boolean']>;
};

export type AdminShopOptionsDrivingRange = {
  __typename?: 'AdminShopOptionsDrivingRange';
  courseId?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['Int']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  isBallTrajectory?: Maybe<Scalars['Boolean']>;
  isFixedCamera?: Maybe<Scalars['Boolean']>;
  isSwingVideo?: Maybe<Scalars['Boolean']>;
  teeHeight?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsDrivingRangeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRealTime = {
  __typename?: 'AdminShopOptionsRealTime';
  drivingRangeTimeLimit?: Maybe<Scalars['Int']>;
  gameHoleTypeLimit?: Maybe<Scalars['Int']>;
  gameTypeLimit?: Maybe<Scalars['Int']>;
  isContentLimit?: Maybe<Scalars['Boolean']>;
  paymentType?: Maybe<Scalars['Int']>;
  playerCountLimit?: Maybe<Scalars['Int']>;
  usageTime?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRealTimeArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopOptionsRound = {
  __typename?: 'AdminShopOptionsRound';
  concede?: Maybe<Scalars['Float']>;
  distanceUnit?: Maybe<Scalars['Int']>;
  greenLocation?: Maybe<Scalars['Int']>;
  greenSpeed?: Maybe<Scalars['Int']>;
  holeCupLocation?: Maybe<Scalars['Int']>;
  isBestVideo?: Maybe<Scalars['Boolean']>;
  isCaddyVoice?: Maybe<Scalars['Boolean']>;
  isUseObHazardTee?: Maybe<Scalars['Boolean']>;
  mulliganCount?: Maybe<Scalars['Int']>;
  puttingLine?: Maybe<Scalars['Int']>;
  useSwingPlate?: Maybe<Scalars['Int']>;
  windSpeed?: Maybe<Scalars['Int']>;
};

export type AdminShopOptionsRoundArgs = {
  accessToken: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminShopTokensInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type AdminSimulatorUsageArgs = {
  accessToken?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type AdminStaffBasic = {
  __typename?: 'AdminStaffBasic';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  userId: Scalars['String'];
};

export type AdminStaffEdge = {
  __typename?: 'AdminStaffEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<AdminStaffBasic>;
};

export type AdminStaffResponse = {
  __typename?: 'AdminStaffResponse';
  edges?: Maybe<Array<Maybe<AdminStaffEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type AdminStaffsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export enum AdminStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Suspended = 'SUSPENDED'
}

export type AdminTerminateMembershipInput = {
  membershipUuid: Scalars['String'];
};

export type AdminUnlockClientInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  drivingRangeTimeLimit: Scalars['Int'];
  gameHoleTypeLimit: Scalars['String'];
  gameTypeLimit: Scalars['String'];
  isContentLimit: Scalars['Boolean'];
  paymentType: Scalars['String'];
  playerCountLimit: Scalars['String'];
  shopGuid: Scalars['String'];
  usageTime: Scalars['Int'];
};

export type AdminUpdateAdminArgs = {
  userId: Scalars['String'];
};

export type AdminUpdateAdminInput = {
  authorizedClubhouses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseCountryCode?: InputMaybe<CountryCode>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileImageFile?: InputMaybe<File>;
};

export type AdminUpdateClientContentLimitInput = {
  accessToken: Scalars['String'];
  clientGuid: Scalars['String'];
  players: Scalars['String'];
  shopGuid: Scalars['String'];
};

export type AdminUpdateCreditInput = {
  amount: Scalars['Float'];
  description: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  transactionType: TransactionType;
  type: AceCoinTransactionType;
};

export type AdminUpdateFacilityInput = {
  facilityName?: InputMaybe<Scalars['String']>;
  facilityType?: InputMaybe<FacilityType>;
  id: Scalars['String'];
};

export type AdminUpdateLessonVoucherInput = {
  amount: Scalars['Int'];
  comment: Scalars['String'];
  date?: InputMaybe<Scalars['DateTime']>;
  lessonVoucherType: LessonVoucherType;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  transactionType: LessonVoucherTransactionType;
  venue?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateMember = {
  __typename?: 'AdminUpdateMember';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  member: AdminMember;
};

export type AdminUpdateMemberInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay?: InputMaybe<Scalars['String']>;
  birthdayMonth?: InputMaybe<Scalars['String']>;
  birthdayYear?: InputMaybe<Scalars['String']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  handed?: InputMaybe<Handed>;
  lastName?: InputMaybe<Scalars['String']>;
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
};

export type AdminUpdateMembershipTypeInput = {
  baseCountryCode?: InputMaybe<CountryCode>;
  compDailySimulatorUse?: InputMaybe<Scalars['Int']>;
  compDailySimulatorUseType?: InputMaybe<CompDailySimulatorUseType>;
  compFieldLessons?: InputMaybe<Scalars['Int']>;
  compIndoorLessons?: InputMaybe<Scalars['Int']>;
  compLocker?: InputMaybe<Scalars['Boolean']>;
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  designatedPrivateRoom?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Int']>;
  imageFile?: InputMaybe<File>;
  initialCredits?: InputMaybe<Scalars['Int']>;
  internalName?: InputMaybe<Scalars['String']>;
  isCorporate?: InputMaybe<Scalars['Boolean']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  loungeAccess?: InputMaybe<Scalars['Boolean']>;
  mainTypeSlug?: InputMaybe<Scalars['String']>;
  monthlySub?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Int']>;
  publicName?: InputMaybe<Scalars['String']>;
  signupProductSidasInsoles?: InputMaybe<Scalars['Boolean']>;
  supplementaryTypeSlug?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<MembershipTypeTier>;
  versionSlug?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateNicknameInput = {
  memberUuid: Scalars['String'];
  newNickname: Scalars['String'];
};

export type AdminUpdateOrganizationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AdminUpdatePricingInput = {
  sgBayHourlyRate?: InputMaybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgBayMaxHours?: InputMaybe<Scalars['Int']>;
  sgBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  sgHole9MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgHole18MaxHours?: InputMaybe<Scalars['Int']>;
  sgHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  sgLessonField?: InputMaybe<Scalars['Int']>;
  sgLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoor?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  sgLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBayHourlyRate?: InputMaybe<Scalars['Int']>;
  viBayHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viBayMaxHours?: InputMaybe<Scalars['Int']>;
  viBayMaxPlayers?: InputMaybe<Scalars['Int']>;
  viBookingCancellationPenalty?: InputMaybe<Scalars['Int']>;
  viBookingLapsedPenalty?: InputMaybe<Scalars['Int']>;
  viHole9MaxHours?: InputMaybe<Scalars['Int']>;
  viHole9MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viHole18MaxHours?: InputMaybe<Scalars['Int']>;
  viHole18MaxPlayers?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRate?: InputMaybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: InputMaybe<Scalars['Int']>;
  viLessonField?: InputMaybe<Scalars['Int']>;
  viLessonFieldVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoor?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: InputMaybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: InputMaybe<Scalars['Int']>;
  viLessonIndoorVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: InputMaybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: InputMaybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: InputMaybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: InputMaybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateReservedId = {
  __typename?: 'AdminUpdateReservedId';
  onHoldExpiresAt?: Maybe<Scalars['DateTime']>;
};

export type AdminUpdateReservedIdInput = {
  hold?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopDetailsInput = {
  CDN?: InputMaybe<Scalars['String']>;
  accessToken?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  introImage?: InputMaybe<Scalars['String']>;
  isParking?: InputMaybe<Scalars['Boolean']>;
  isShopCloseNextDay?: InputMaybe<Scalars['Boolean']>;
  logoImage?: InputMaybe<Scalars['String']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  ownerMobilePhone?: InputMaybe<Scalars['String']>;
  ownerMobilePhoneCountry?: InputMaybe<Scalars['String']>;
  ownerName?: InputMaybe<Scalars['String']>;
  shopCloseTime?: InputMaybe<Scalars['String']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  shopName?: InputMaybe<Scalars['String']>;
  shopOpenTime?: InputMaybe<Scalars['String']>;
  shopPhone?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type AdminUpdateShopOptionsDrivingRangeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  difficulty?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  isBallTrajectory?: InputMaybe<Scalars['Boolean']>;
  isFixedCamera?: InputMaybe<Scalars['Boolean']>;
  isSwingVideo?: InputMaybe<Scalars['Boolean']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  teeHeight?: InputMaybe<Scalars['Int']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRealTimeInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  drivingRangeTimeLimit?: InputMaybe<Scalars['Int']>;
  gameHoleTypeLimit?: InputMaybe<Scalars['Int']>;
  gameTypeLimit?: InputMaybe<Scalars['Int']>;
  isContentLimit?: InputMaybe<Scalars['Boolean']>;
  paymentType?: InputMaybe<Scalars['Int']>;
  playerCountLimit?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  usageTime?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateShopOptionsRoundInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  concede?: InputMaybe<Scalars['Int']>;
  distanceUnit?: InputMaybe<Scalars['Int']>;
  greenLocation?: InputMaybe<Scalars['Int']>;
  greenSpeed?: InputMaybe<Scalars['Int']>;
  holeCupLocation?: InputMaybe<Scalars['Int']>;
  isBestVideo?: InputMaybe<Scalars['Boolean']>;
  isCaddyVoice?: InputMaybe<Scalars['Boolean']>;
  isUseObHazardTee?: InputMaybe<Scalars['Boolean']>;
  mulliganCount?: InputMaybe<Scalars['Int']>;
  puttingLine?: InputMaybe<Scalars['Int']>;
  shopGuid?: InputMaybe<Scalars['String']>;
  useSwingPlate?: InputMaybe<Scalars['Int']>;
  windSpeed?: InputMaybe<Scalars['Int']>;
};

export type AdminUpdateSidasInsolesInput = {
  memberUuid: Scalars['String'];
  transactionType: AdminUpdateSidasInsolesTransactionType;
};

export enum AdminUpdateSidasInsolesTransactionType {
  Adjustment = 'ADJUSTMENT',
  Complimentary = 'COMPLIMENTARY',
  Redemption = 'REDEMPTION'
}

export type AdminsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
};

export type AdmnUpdateSubscriptionInput = {
  isPaused: Scalars['Boolean'];
  membershipUuid: Scalars['String'];
};

export type AppDineMenu = {
  __typename?: 'AppDineMenu';
  foodUri?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  wineUri?: Maybe<Scalars['String']>;
};

export type AppDineMenuArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSlider = {
  __typename?: 'AppMainSlider';
  slides: Array<AppMainSliderSlide>;
};

export type AppMainSliderArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type AppMainSliderSlide = {
  __typename?: 'AppMainSliderSlide';
  id: Scalars['ID'];
  link?: Maybe<AppMainSliderSlideLink>;
  posterTitle?: Maybe<Scalars['String']>;
  posterUri?: Maybe<Scalars['String']>;
  slideUri?: Maybe<Scalars['String']>;
};

export type AppMainSliderSlideLink = {
  __typename?: 'AppMainSliderSlideLink';
  route?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum AuditLogActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

export type AuthenticatedAdmin = {
  __typename?: 'AuthenticatedAdmin';
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouses: Array<Maybe<Scalars['String']>>;
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  profileImageUrl: Scalars['String'];
  ud?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: Scalars['String'];
  yourIp: Scalars['String'];
};

export type AuthenticatedMember = {
  __typename?: 'AuthenticatedMember';
  id: Scalars['String'];
  memberId?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type BasicClubhouseDetails = {
  __typename?: 'BasicClubhouseDetails';
  clubhouseCode: Scalars['String'];
  name: Scalars['String'];
};

export type BaySimulator = {
  __typename?: 'BaySimulator';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum BookingStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export enum BookingType {
  Game = 'GAME',
  LessonField = 'LESSON_FIELD',
  LessonIndoor = 'LESSON_INDOOR',
  Practise = 'PRACTISE'
}

export enum CancelledBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type ClientStatus = {
  __typename?: 'ClientStatus';
  clients: Scalars['JSON'];
  shopGuid: Scalars['String'];
};

export type ClubhouseOrganization = {
  __typename?: 'ClubhouseOrganization';
  businessName: Scalars['String'];
  id: Scalars['String'];
};

export type ClubhouseOverride = {
  __typename?: 'ClubhouseOverride';
  closureMessage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type Coach = SystemUser & {
  __typename?: 'Coach';
  baseCountryCode?: Maybe<CountryCode>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastAccessTokenDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<LoginInfo>;
  lastLoginDate?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: AdminOrganization;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type CoachBookingBasic = {
  __typename?: 'CoachBookingBasic';
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
  id: Scalars['String'];
  member: AdminBookingBasicMember;
  resourceName?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  status: BookingStatus;
  type: BookingType;
  venue?: Maybe<Scalars['String']>;
};

export type CoachBookingEdge = {
  __typename?: 'CoachBookingEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CoachBookingBasic>;
};

export type CoachBookingResponse = {
  __typename?: 'CoachBookingResponse';
  edges?: Maybe<Array<Maybe<CoachBookingEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CoachBookingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  nameFilter?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderBy>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
};

export type CoachCalendarAvailability = {
  __typename?: 'CoachCalendarAvailability';
  clubhouses: Array<Maybe<Scalars['String']>>;
  date: Scalars['String'];
};

export type CoachDayAvailability = {
  __typename?: 'CoachDayAvailability';
  b0800?: Maybe<Scalars['String']>;
  b0900?: Maybe<Scalars['String']>;
  b1000?: Maybe<Scalars['String']>;
  b1100?: Maybe<Scalars['String']>;
  b1200?: Maybe<Scalars['String']>;
  b1300?: Maybe<Scalars['String']>;
  b1400?: Maybe<Scalars['String']>;
  b1500?: Maybe<Scalars['String']>;
  b1600?: Maybe<Scalars['String']>;
  b1700?: Maybe<Scalars['String']>;
  b1800?: Maybe<Scalars['String']>;
  b1900?: Maybe<Scalars['String']>;
  b2000?: Maybe<Scalars['String']>;
  b2100?: Maybe<Scalars['String']>;
  b2200?: Maybe<Scalars['String']>;
  b2300?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  l0800?: Maybe<Scalars['String']>;
  l0900?: Maybe<Scalars['String']>;
  l1000?: Maybe<Scalars['String']>;
  l1100?: Maybe<Scalars['String']>;
  l1200?: Maybe<Scalars['String']>;
  l1300?: Maybe<Scalars['String']>;
  l1400?: Maybe<Scalars['String']>;
  l1500?: Maybe<Scalars['String']>;
  l1600?: Maybe<Scalars['String']>;
  l1700?: Maybe<Scalars['String']>;
  l1800?: Maybe<Scalars['String']>;
  l1900?: Maybe<Scalars['String']>;
  l2000?: Maybe<Scalars['String']>;
  l2100?: Maybe<Scalars['String']>;
  l2200?: Maybe<Scalars['String']>;
  l2300?: Maybe<Scalars['String']>;
};

export type CoachDayAvailabilityArgs = {
  dateId: Scalars['String'];
};

export type CoachForPublic = {
  __typename?: 'CoachForPublic';
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLessonField?: Maybe<Scalars['Int']>;
  coachLessonFieldVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoor?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  coachLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  coachLessonIndoorVIP?: Maybe<Scalars['Int']>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export enum CoachLevel {
  Pro = 'PRO',
  SemiPro = 'SEMI_PRO'
}

export type CoachUpsertDayAvailabilityInput = {
  date: Scalars['String'];
  l0800?: InputMaybe<Scalars['String']>;
  l0900?: InputMaybe<Scalars['String']>;
  l1000?: InputMaybe<Scalars['String']>;
  l1100?: InputMaybe<Scalars['String']>;
  l1200?: InputMaybe<Scalars['String']>;
  l1300?: InputMaybe<Scalars['String']>;
  l1400?: InputMaybe<Scalars['String']>;
  l1500?: InputMaybe<Scalars['String']>;
  l1600?: InputMaybe<Scalars['String']>;
  l1700?: InputMaybe<Scalars['String']>;
  l1800?: InputMaybe<Scalars['String']>;
  l1900?: InputMaybe<Scalars['String']>;
  l2000?: InputMaybe<Scalars['String']>;
  l2100?: InputMaybe<Scalars['String']>;
  l2200?: InputMaybe<Scalars['String']>;
  l2300?: InputMaybe<Scalars['String']>;
};

export enum CompDailySimulatorUseType {
  Na = 'NA',
  Restricted = 'RESTRICTED',
  Unrestricted = 'UNRESTRICTED'
}

export enum CountryCode {
  Sg = 'SG',
  Vi = 'VI'
}

export type CreateMemberInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry: Scalars['String'];
  addressPostalCode: Scalars['String'];
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  bankTransferRef?: InputMaybe<Scalars['String']>;
  birthdayDay: Scalars['String'];
  birthdayMonth: Scalars['String'];
  birthdayYear: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  mobileNumber: Scalars['String'];
  partialNricOrFin?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
  relationshipToMainMember?: InputMaybe<Relationship>;
  sameAddressAsMainMember?: InputMaybe<Scalars['Boolean']>;
};

export enum CreatedBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  amount: Scalars['Float'];
  authorizedAdjuster?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSpent?: Maybe<Scalars['Boolean']>;
  membership?: Maybe<CreditTransactionMembership>;
  transactionType?: Maybe<CreditTransactionType>;
};

export type CreditTransactionMembership = {
  __typename?: 'CreditTransactionMembership';
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export enum CreditTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type DevAnalyticsCreditTransactions = {
  __typename?: 'DevAnalyticsCreditTransactions';
  memberName: Scalars['String'];
  memberUuid: Scalars['String'];
  membershipUuid: Scalars['String'];
  noOfCreditTransactions: Scalars['Int'];
};

export type DevEMenuImportOrdersInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
};

export type DevEMenuMatchOrders = {
  __typename?: 'DevEMenuMatchOrders';
  numberOfOrdersMatched?: Maybe<Scalars['Int']>;
};

export type DevEMenuMatchOrdersInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevEMenuUpsertCreditTransactionsInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevKGolfMemberJoin = {
  __typename?: 'DevKGolfMemberJoin';
  kGolfAccountCreationError: Scalars['Boolean'];
  kGolfPassword: Scalars['String'];
  kGolfUserId: Scalars['String'];
  nickname: Scalars['String'];
};

export type DevMemberMigrationCreditTransactions = {
  __typename?: 'DevMemberMigrationCreditTransactions';
  numberOfTransactionsProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationCreditTransactionsInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationGender = {
  __typename?: 'DevMemberMigrationGender';
  numberOfMembersProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationGenderInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationLessonVouchers = {
  __typename?: 'DevMemberMigrationLessonVouchers';
  numberOfLessonVouchersProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationLessonVouchersInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationLoginId = {
  __typename?: 'DevMemberMigrationLoginId';
  numberOfMembersProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationLoginIdInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationMembershipType = {
  __typename?: 'DevMemberMigrationMembershipType';
  numberOfMembershipsProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationMembershipTypeInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationNickname = {
  __typename?: 'DevMemberMigrationNickname';
  numberOfMembersProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationNicknameInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationStartDate = {
  __typename?: 'DevMemberMigrationStartDate';
  numberOfMembersProcessed?: Maybe<Scalars['Int']>;
  numberOfMembershipsProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationStartDateInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevMemberMigrationSubscriptions = {
  __typename?: 'DevMemberMigrationSubscriptions';
  numberOfSubscriptionsProcessed?: Maybe<Scalars['Int']>;
};

export type DevMemberMigrationSubscriptionsInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevUserMigrationLastAccessTokenDateInput = {
  temp?: InputMaybe<Scalars['String']>;
};

export type DevUtilityEnvs = {
  __typename?: 'DevUtilityEnvs';
  kGolfEnv: Scalars['JSON'];
};

export enum DeviceType {
  Mobile = 'MOBILE',
  Pc = 'PC',
  Tablet = 'TABLET'
}

export enum Direction {
  Asc = 'asc',
  Desc = 'desc'
}

export enum DurationType {
  Hour = 'HOUR',
  Min = 'MIN'
}

export type Facility = {
  __typename?: 'Facility';
  clientGuid?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  clientOrder?: Maybe<Scalars['Int']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityType?: Maybe<FacilityType>;
  id?: Maybe<Scalars['String']>;
};

export enum FacilityType {
  OpenBay = 'OPEN_BAY',
  PrivateRoom = 'PRIVATE_ROOM',
  PuttingGreen = 'PUTTING_GREEN'
}

export type File = {
  name: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
};

export type FileUploadCredentials = {
  __typename?: 'FileUploadCredentials';
  fields: Scalars['JSONObject'];
  signedUrl: Scalars['String'];
};

export type FileUploadObject = {
  __typename?: 'FileUploadObject';
  assetUrl: Scalars['String'];
  clientImageFieldName: Scalars['String'];
  fields: Scalars['JSONObject'];
  index: Scalars['Int'];
  signedUrl: Scalars['String'];
};

export type FormHelperBooking = {
  __typename?: 'FormHelperBooking';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperBookingArgs = {
  countryCode?: InputMaybe<CountryCode>;
};

export type FormHelperNewAdmin = {
  __typename?: 'FormHelperNewAdmin';
  clubhouses: Array<Maybe<AdminClubhouseBasic>>;
};

export type FormHelperNewAdminArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewCoach = {
  __typename?: 'FormHelperNewCoach';
  countries: Array<Maybe<Scalars['String']>>;
};

export type FormHelperNewCoachArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembership = {
  __typename?: 'FormHelperNewMembership';
  membershipTypes: Array<Maybe<FormHelperNewMembershipMembershipType>>;
};

export type FormHelperNewMembershipArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type FormHelperNewMembershipMembershipType = {
  __typename?: 'FormHelperNewMembershipMembershipType';
  hasReservedIds?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  internalName: Scalars['String'];
  supplementaryTypeSlug?: Maybe<Scalars['String']>;
  versionSlug: Scalars['String'];
};

export type FreeLesson = {
  __typename?: 'FreeLesson';
  amount?: Maybe<Scalars['Int']>;
  authorizedAdjuster?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  transactionType?: Maybe<FreeLessonTransactionType>;
  type?: Maybe<FreeLessonType>;
  venue?: Maybe<Scalars['String']>;
};

export enum FreeLessonTransactionType {
  Added = 'ADDED',
  Used = 'USED'
}

export enum FreeLessonType {
  Field = 'FIELD',
  Indoor = 'INDOOR'
}

export enum GameCourseType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export type GameRound = {
  __typename?: 'GameRound';
  cdn: Scalars['String'];
  scorecard: Array<Maybe<GameRoundScoreCard>>;
};

export type GameRoundCourseInfo = {
  __typename?: 'GameRoundCourseInfo';
  courseInTotalPar: Scalars['Int'];
  courseOutTotalPar: Scalars['Int'];
  coursePar: Array<Scalars['Int']>;
  courseTotalPar: Scalars['Int'];
  intro: Scalars['String'];
  logo: Scalars['String'];
  newPerioHiddenHole: Scalars['String'];
};

export type GameRoundGameInfo = {
  __typename?: 'GameRoundGameInfo';
  clientGuid: Scalars['String'];
  clientName: Scalars['String'];
  completeHoleCount: Scalars['Int'];
  concede: Scalars['Int'];
  courseInfo: GameRoundCourseInfo;
  courseName: Scalars['String'];
  distanceUnit: Scalars['String'];
  gameEndTime: Scalars['Int'];
  gameHoleType: Scalars['String'];
  gameRoundId: Scalars['Int'];
  gameStartTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  greenLocation: Scalars['String'];
  greenSpeed: Scalars['String'];
  holeCupLocation: Scalars['String'];
  isBestVideo: Scalars['Boolean'];
  isCaddyVoice: Scalars['Boolean'];
  isUseObHazardTee: Scalars['Boolean'];
  mulliganCount: Scalars['Int'];
  playHoleCount: Scalars['Int'];
  puttingLine: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
  tournamentIdx: Scalars['Int'];
  useSwingPlate: Scalars['String'];
  windSpeed: Scalars['String'];
};

export type GameRoundHoleInfo = {
  __typename?: 'GameRoundHoleInfo';
  holeNumber: Scalars['Int'];
  holeOutType: Scalars['Int'];
  isBestVideo: Scalars['Boolean'];
  isConcede: Scalars['Boolean'];
  isLongest: Scalars['Boolean'];
  isMulligan: Scalars['Boolean'];
  isNearpin: Scalars['Boolean'];
  score: Scalars['Int'];
};

export type GameRoundPlayerInfo = {
  __typename?: 'GameRoundPlayerInfo';
  completeHoleCount: Scalars['Int'];
  difficulty: Scalars['Int'];
  handicap: Scalars['Int'];
  holeInfo: Array<GameRoundHoleInfo>;
  inTotalScore: Scalars['Int'];
  nickname: Scalars['String'];
  outTotalScore: Scalars['Int'];
  playerType: Scalars['Int'];
  rank: Scalars['Int'];
  startHole: Scalars['Int'];
  team: Scalars['Int'];
  totalScore: Scalars['String'];
  userGuid: Scalars['String'];
};

export type GameRoundScoreCard = {
  __typename?: 'GameRoundScoreCard';
  gameInfo: GameRoundGameInfo;
  playerInfo: Array<Maybe<GameRoundPlayerInfo>>;
};

export enum GameType {
  Hole_9 = 'HOLE_9',
  Hole_18 = 'HOLE_18'
}

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Undisclosed = 'UNDISCLOSED'
}

export enum Handed {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type HitPayPaymentRequest = {
  __typename?: 'HitPayPaymentRequest';
  checkoutUrl?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
};

export enum IndoorLocation {
  BaySimulator = 'BAY_SIMULATOR',
  PrivateRoom = 'PRIVATE_ROOM',
  PuttingGreen = 'PUTTING_GREEN'
}

export type KGolfLoginData = {
  __typename?: 'KGolfLoginData';
  access_token?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  expires_in?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refresh_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  token_type?: Maybe<Scalars['String']>;
};

export type KGolfMemberGet = {
  __typename?: 'KGolfMemberGet';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: Maybe<Scalars['Boolean']>;
  mobilePhone?: Maybe<Scalars['String']>;
  mobilePhoneCountry?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  zipcode?: Maybe<Scalars['String']>;
};

export type KGolfMemberJoin = {
  __typename?: 'KGolfMemberJoin';
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfUserId?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
};

export type KGolfMemberLogin = {
  __typename?: 'KGolfMemberLogin';
  accessToken?: Maybe<Scalars['String']>;
  cdn?: Maybe<Scalars['String']>;
  ewxpiresIn?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  guid?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  profilePath?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfShopLogin = {
  __typename?: 'KGolfShopLogin';
  accessToken?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['Int']>;
  managerId?: Maybe<Scalars['String']>;
  managerIdx?: Maybe<Scalars['Int']>;
  managerName?: Maybe<Scalars['String']>;
  managerType?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  shopGuid?: Maybe<Scalars['String']>;
  shopName?: Maybe<Scalars['String']>;
  tokenType?: Maybe<Scalars['String']>;
};

export type KGolfUpdateMemberInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Int']>;
  isTermsAgreeNotificationSMS?: InputMaybe<Scalars['Boolean']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  mobilePhoneCountry?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type LegacyBenefitGiftProduct = {
  __typename?: 'LegacyBenefitGiftProduct';
  name: Scalars['String'];
  value: Scalars['Int'];
};

export type LegacyBooking = {
  __typename?: 'LegacyBooking';
  bookingLineItems?: Maybe<Array<Maybe<LegacyBookingLineItem>>>;
  cancellByAdminId?: Maybe<Scalars['String']>;
  cancellationDateTime?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<CancelledBy>;
  coachDisplayName?: Maybe<Scalars['String']>;
  coachId?: Maybe<Scalars['String']>;
  compFieldLessonToDeduct?: Maybe<Scalars['Int']>;
  compIndoorLessonToDeduct?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditToDeduct?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['DateTime']>;
  fieldLessonDetails?: Maybe<Scalars['String']>;
  fieldLessonVenue?: Maybe<Scalars['String']>;
  gameCourseType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  indoorLocation?: Maybe<IndoorLocation>;
  location?: Maybe<IndoorLocation>;
  member?: Maybe<LegacyMember>;
  noOfPlayers?: Maybe<Scalars['Int']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  resourceName?: Maybe<Scalars['String']>;
  slots?: Maybe<Array<Maybe<Scalars['Int']>>>;
  startTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<BookingStatus>;
  type?: Maybe<BookingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  venue?: Maybe<Scalars['String']>;
};

export type LegacyBookingLineItem = {
  __typename?: 'LegacyBookingLineItem';
  amount?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type LegacyClubhouse = {
  __typename?: 'LegacyClubhouse';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  baySimulators: Array<Maybe<BaySimulator>>;
  clubhouseCode?: Maybe<Scalars['String']>;
  clubhouseId: Scalars['String'];
  colorCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  day0EndTime?: Maybe<Scalars['Int']>;
  day0StartTime?: Maybe<Scalars['Int']>;
  day1EndTime?: Maybe<Scalars['Int']>;
  day1StartTime?: Maybe<Scalars['Int']>;
  day2EndTime?: Maybe<Scalars['Int']>;
  day2StartTime?: Maybe<Scalars['Int']>;
  day3EndTime?: Maybe<Scalars['Int']>;
  day3StartTime?: Maybe<Scalars['Int']>;
  day4EndTime?: Maybe<Scalars['Int']>;
  day4StartTime?: Maybe<Scalars['Int']>;
  day5EndTime?: Maybe<Scalars['Int']>;
  day5StartTime?: Maybe<Scalars['Int']>;
  day6EndTime?: Maybe<Scalars['Int']>;
  day6StartTime?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  kGolfClientId?: Maybe<Scalars['String']>;
  kGolfClientSecret?: Maybe<Scalars['String']>;
  kGolfDevClientId?: Maybe<Scalars['String']>;
  kGolfDevClientSecret?: Maybe<Scalars['String']>;
  kGolfDevPassword?: Maybe<Scalars['String']>;
  kGolfDevUsername?: Maybe<Scalars['String']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfUsername?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfPrivateRooms?: Maybe<Scalars['Int']>;
  noOfPuttingGreen?: Maybe<Scalars['Int']>;
  noOfSimulators?: Maybe<Scalars['Int']>;
  organization: LegacyClubhouseOrganization;
  organizationId: Scalars['String'];
  overrides: Array<Maybe<LegacyClubhouseOverride>>;
  phoneNumber?: Maybe<Scalars['String']>;
  privateRooms: Array<Maybe<PrivateRoom>>;
  puttingGreens: Array<Maybe<PuttingGreen>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegacyClubhouseOrganization = {
  __typename?: 'LegacyClubhouseOrganization';
  businessName: Scalars['String'];
  emailDomains: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type LegacyClubhouseOverride = {
  __typename?: 'LegacyClubhouseOverride';
  closureMessage?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
};

export type LegacyCoach = LegacySystemUser & {
  __typename?: 'LegacyCoach';
  bookings: Array<Maybe<LegacyBooking>>;
  coachAvailabilities: Array<Maybe<LegacyCoachAvailability>>;
  coachBirthPlace?: Maybe<Scalars['String']>;
  coachBirthdate?: Maybe<Scalars['String']>;
  coachExperiences?: Maybe<Scalars['JSON']>;
  coachExpertise?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLanguages?: Maybe<Array<Maybe<Scalars['String']>>>;
  coachLevel?: Maybe<CoachLevel>;
  coachListOrder?: Maybe<Scalars['Int']>;
  coachPGANo?: Maybe<Scalars['String']>;
  coachPGAType?: Maybe<Scalars['String']>;
  coachPGAYear?: Maybe<Scalars['String']>;
  coachSavedSlots1?: Maybe<Array<Maybe<Scalars['Int']>>>;
  coachSavedSlots2?: Maybe<Array<Maybe<Scalars['Int']>>>;
  coachSavedSlots3?: Maybe<Array<Maybe<Scalars['Int']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender?: Maybe<LegacyUserGender>;
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: LegacyUserOrganization;
  profileImageUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type LegacyCoachAvailability = {
  __typename?: 'LegacyCoachAvailability';
  blockedSlots: Array<Maybe<Scalars['Int']>>;
  clubhouseCode: Scalars['String'];
  date: Scalars['DateTime'];
  fullyBooked: Scalars['Boolean'];
  hasIndoorBookings: Scalars['Boolean'];
  id: Scalars['String'];
};

export type LegacyCoachDayBookings = {
  __typename?: 'LegacyCoachDayBookings';
  bookedSlots?: Maybe<Array<Maybe<Scalars['Int']>>>;
  hasFieldBooking?: Maybe<Scalars['Boolean']>;
};

export type LegacyCoachDayBookingsInput = {
  date?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type LegacyCreateCoachDayAvailability = {
  __typename?: 'LegacyCreateCoachDayAvailability';
  hasAvailabiliity?: Maybe<Scalars['Boolean']>;
};

export type LegacyCreateCoachDayAvailabilityInput = {
  availableSlots?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  clubhouseCode: Scalars['String'];
  date: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type LegacyCreateCoachSavedSlotsInput = {
  availableSlots?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  templateNumber?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type LegacyCreditTransaction = {
  __typename?: 'LegacyCreditTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  membership?: Maybe<LegacyCreditTransactionMembership>;
  transactionType?: Maybe<CreditTransactionType>;
};

export type LegacyCreditTransactionMembership = {
  __typename?: 'LegacyCreditTransactionMembership';
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
};

export type LegacyFreeLessonHistory = {
  __typename?: 'LegacyFreeLessonHistory';
  amount?: Maybe<Scalars['Int']>;
  authorizedAdjuster?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  transactionType?: Maybe<LegacyFressLessonTransactionType>;
  type?: Maybe<LegacyFreeLessonType>;
  venue?: Maybe<Scalars['String']>;
};

export enum LegacyFreeLessonType {
  Field = 'FIELD',
  Indoor = 'INDOOR'
}

export enum LegacyFressLessonTransactionType {
  Added = 'ADDED',
  Used = 'USED'
}

export type LegacyMember = {
  __typename?: 'LegacyMember';
  accountType?: Maybe<AccountType>;
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  bookings: Array<Maybe<LegacyBooking>>;
  companyContactPersonEmail?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dailySimulatorTicketUseDate?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  friends?: Maybe<Array<Maybe<LegacyMember>>>;
  gender?: Maybe<Gender>;
  giftSidasCustomisedInsoles?: Maybe<Scalars['Int']>;
  handed?: Maybe<Handed>;
  id?: Maybe<Scalars['String']>;
  individualId?: Maybe<Scalars['String']>;
  isTermsAgreeNotification?: Maybe<Scalars['Boolean']>;
  kGolfPassword?: Maybe<Scalars['String']>;
  kGolfUserId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mainId?: Maybe<Scalars['String']>;
  mainMember?: Maybe<LegacyMember>;
  memberStatus?: Maybe<MemberStatus>;
  membership?: Maybe<LegacyMembership>;
  membershipType?: Maybe<LegacyMembershipType>;
  mobileNumber?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  organization?: Maybe<LegacyOrganization>;
  partialNricOrFin?: Maybe<Scalars['String']>;
  payments?: Maybe<Array<Maybe<LegacyPayment>>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  relationshipToMainMember?: Maybe<Scalars['String']>;
  subMembers?: Maybe<Array<Maybe<LegacyMember>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userGuid?: Maybe<Scalars['String']>;
};

export type LegacyMembership = {
  __typename?: 'LegacyMembership';
  compFieldLessons?: Maybe<Scalars['Int']>;
  compIndoorLessons?: Maybe<Scalars['Int']>;
  compLocker?: Maybe<Scalars['Boolean']>;
  compProducts?: Maybe<Scalars['JSON']>;
  compSidasGolf3D?: Maybe<Scalars['Int']>;
  compSidasInsoles?: Maybe<Scalars['Int']>;
  companyContactPersonDesignation?: Maybe<Scalars['String']>;
  companyContactPersonEmail?: Maybe<Scalars['String']>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyIndustry?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  credit?: Maybe<Scalars['Float']>;
  creditSpent?: Maybe<Scalars['Float']>;
  creditTransactions?: Maybe<Array<Maybe<LegacyCreditTransaction>>>;
  defaultMembershipTypeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  freeLessonHistories?: Maybe<Array<Maybe<LegacyFreeLessonHistory>>>;
  id?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  members?: Maybe<Array<Maybe<LegacyMember>>>;
  membershipId?: Maybe<Scalars['String']>;
  membershipStatus?: Maybe<Scalars['String']>;
  membershipType?: Maybe<LegacyMembershipType>;
  membershipTypeId?: Maybe<Scalars['String']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  payments?: Maybe<Array<Maybe<LegacyPayment>>>;
  startDate?: Maybe<Scalars['DateTime']>;
  subscriptionEndDate?: Maybe<Scalars['DateTime']>;
  subscriptionStartDate?: Maybe<Scalars['DateTime']>;
  subscriptionStatus?: Maybe<SubscriptionStatus>;
  subscriptions?: Maybe<Array<Maybe<LegacySubscription>>>;
};

export enum LegacyMembershipIdFormat {
  Common = 'COMMON',
  Inherit = 'INHERIT',
  Vip = 'VIP'
}

export type LegacyMembershipType = {
  __typename?: 'LegacyMembershipType';
  addressRequired?: Maybe<Scalars['Boolean']>;
  compDailySimulatorUse?: Maybe<Scalars['Int']>;
  compDailySimulatorUseDescription?: Maybe<Scalars['String']>;
  compDailySimulatorValue?: Maybe<Scalars['Int']>;
  compFieldLessons?: Maybe<Scalars['Int']>;
  compFieldLessonsValue?: Maybe<Scalars['Int']>;
  compIndoorLessons?: Maybe<Scalars['Int']>;
  compIndoorLessonsValue?: Maybe<Scalars['Int']>;
  compLocker?: Maybe<Scalars['Boolean']>;
  compLockerValue?: Maybe<Scalars['Int']>;
  defaultType?: Maybe<Scalars['Boolean']>;
  designatedPrivateRoom?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Int']>;
  displayName?: Maybe<Scalars['String']>;
  hasReservedIds?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  initialCredits?: Maybe<Scalars['Int']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  loungeAccess?: Maybe<Scalars['Boolean']>;
  maxMembers?: Maybe<Scalars['Int']>;
  membershipIdFormat?: Maybe<LegacyMembershipIdFormat>;
  parentTypeId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  privateRoomPriorityBooking?: Maybe<Scalars['Boolean']>;
  products?: Maybe<Array<Maybe<LegacyBenefitGiftProduct>>>;
  slug?: Maybe<Scalars['String']>;
  tier?: Maybe<LegacyMembershipTypeTier>;
};

export enum LegacyMembershipTypeTier {
  Lifestyle = 'LIFESTYLE',
  Premium = 'PREMIUM',
  Vip = 'VIP'
}

export type LegacyOrganization = {
  __typename?: 'LegacyOrganization';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<LegacyClubhouse>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailDomains: Array<Scalars['String']>;
  id: Scalars['String'];
  organizationNumber: Scalars['Int'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<LegacyUser>>>;
};

export type LegacyPayment = {
  __typename?: 'LegacyPayment';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<Maybe<LegacyPaymentLineItem>>>;
  memberName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentCode?: Maybe<PaymentCode>;
  paymentMode?: Maybe<PaymentMode>;
  paymentProvider?: Maybe<LegacyPaymentProvider>;
  providerRefId?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  status?: Maybe<PaymentStatus>;
  taxes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LegacyPaymentLineItem = {
  __typename?: 'LegacyPaymentLineItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<LegacyPaymentLineItemType>;
};

export enum LegacyPaymentLineItemType {
  Credit = 'CREDIT',
  MembershipActivation = 'MEMBERSHIP_ACTIVATION',
  MembershipType = 'MEMBERSHIP_TYPE',
  VipNumber = 'VIP_NUMBER'
}

export enum LegacyPaymentProvider {
  Emenu = 'EMENU',
  Hitpay = 'HITPAY',
  Nil = 'NIL'
}

export type LegacySubscription = {
  __typename?: 'LegacySubscription';
  amount?: Maybe<Scalars['Float']>;
  creditDeducted?: Maybe<Scalars['Boolean']>;
  days?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  membership?: Maybe<LegacyMembership>;
  membershipId?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type LegacySystemUser = {
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: LegacyUserOrganization;
  profileImageUrl?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export type LegacyUser = LegacySystemUser & {
  __typename?: 'LegacyUser';
  authorizedClubhouses?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization: LegacyUserOrganization;
  permissions: Array<Maybe<Scalars['String']>>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status: AdminStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType: UserType;
};

export enum LegacyUserGender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type LegacyUserOrganization = {
  __typename?: 'LegacyUserOrganization';
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<BasicClubhouseDetails>>>;
  emailDomains: Array<Scalars['String']>;
  id: Scalars['String'];
};

export type LessonVoucher = {
  __typename?: 'LessonVoucher';
  amount?: Maybe<Scalars['Int']>;
  authorizedAdjuster?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  transactionType?: Maybe<LessonVoucherTransactionType>;
  type?: Maybe<LessonVoucherType>;
  venue?: Maybe<Scalars['String']>;
};

export enum LessonVoucherTransactionType {
  Adjustment = 'ADJUSTMENT',
  Award = 'AWARD',
  Purchase = 'PURCHASE',
  Redemption = 'REDEMPTION',
  Transfer = 'TRANSFER'
}

export enum LessonVoucherType {
  Field = 'FIELD',
  Indoor = 'INDOOR'
}

export type LineItem = {
  __typename?: 'LineItem';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  eMenuId?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['Int']>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  salesPrice: Scalars['Float'];
  transactionId?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export type LineItemInput = {
  __typename?: 'LineItemInput';
  brand?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  itemName: Scalars['String'];
  mCategoryId?: Maybe<Scalars['Int']>;
  mainCategory?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  salesPrice: Scalars['Float'];
  vendor?: Maybe<Scalars['String']>;
};

export type LoginInfo = {
  __typename?: 'LoginInfo';
  city?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['DateTime']>;
};

export type ManagementSystem = {
  __typename?: 'ManagementSystem';
  eventId: Scalars['String'];
  operation?: Maybe<ManagementSystemPublishOperation>;
  ref?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userProfileImageUrl?: Maybe<Scalars['String']>;
};

export enum ManagementSystemPublishOperation {
  AdminUpdateMember = 'ADMIN_UPDATE_MEMBER',
  AdminUpdateOrganization = 'ADMIN_UPDATE_ORGANIZATION'
}

export type MemberAccount = {
  __typename?: 'MemberAccount';
  aceCoin: MemberAccountAceCoin;
  benefits: MemberAccountBenefits;
  defaultBaseCountryCode: CountryCode;
  defaultGmtOffset: Scalars['Int'];
  profile: MemberAccountProfile;
  simulator: MemberAccountSimulator;
};

export type MemberAccountAceCoin = {
  __typename?: 'MemberAccountAceCoin';
  balance: Scalars['Float'];
  currentSpent: Scalars['Float'];
};

export type MemberAccountBenefits = {
  __typename?: 'MemberAccountBenefits';
  freeFieldLessons: Scalars['Int'];
  freeIndoorLessons: Scalars['Int'];
  sidasInsoles: Scalars['Int'];
  simulatorHasPrivilege?: Maybe<Scalars['Boolean']>;
  simulatorHasPrivilegeHrs?: Maybe<Scalars['Int']>;
  simulatorUsageConditionMonFri?: Maybe<Scalars['String']>;
  simulatorUsageConditionMonSun?: Maybe<Scalars['String']>;
  simulatorUsageConditionSatSun?: Maybe<Scalars['String']>;
  simulatorUsageDateStr?: Maybe<Scalars['String']>;
  simulatorUsageTimeStr?: Maybe<Scalars['String']>;
};

export type MemberAccountProfile = {
  __typename?: 'MemberAccountProfile';
  creditToNextLevel: Scalars['Float'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  gender: Gender;
  handed: Handed;
  lastName: Scalars['String'];
  memberId: Scalars['String'];
  membershipDisplayName: Scalars['String'];
  mobileNumber: Scalars['String'];
  nextLevelDisplayName: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type MemberAccountSimulator = {
  __typename?: 'MemberAccountSimulator';
  nickname: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['String'];
};

export type MemberAddPushTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  pushToken: Scalars['String'];
};

export type MemberApp = {
  __typename?: 'MemberApp';
  eventId?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
  operation?: Maybe<MemberAppPublishOperation>;
};

export type MemberAppArgs = {
  memberUuid: Scalars['String'];
};

export enum MemberAppPublishOperation {
  UpdatedAccount = 'UPDATED_ACCOUNT'
}

export type MemberAuditDataInput = {
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
};

export enum MemberAuditLogEventName {
  Login = 'LOGIN'
}

export type MemberAuditLogSaveDataInput = {
  actionType?: InputMaybe<AuditLogActionType>;
  appVersion?: InputMaybe<Scalars['String']>;
  browserName?: InputMaybe<Scalars['String']>;
  browserVersion?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  deviceBrand?: InputMaybe<Scalars['String']>;
  deviceModelId?: InputMaybe<Scalars['String']>;
  deviceModelName?: InputMaybe<Scalars['String']>;
  deviceName?: InputMaybe<Scalars['String']>;
  eventName?: InputMaybe<MemberAuditLogEventName>;
  ipAddress?: InputMaybe<Scalars['String']>;
  memberId: Scalars['String'];
  osName?: InputMaybe<Scalars['String']>;
  osVersion?: InputMaybe<Scalars['String']>;
  typeRefId?: InputMaybe<Scalars['String']>;
};

export type MemberAuthResponse = {
  __typename?: 'MemberAuthResponse';
  accessToken: Scalars['String'];
  authenticatedMember: AuthenticatedMember;
  refreshToken: Scalars['String'];
};

export type MemberBasic = {
  __typename?: 'MemberBasic';
  accountType?: Maybe<AccountType>;
  companyContactPersonFirstName?: Maybe<Scalars['String']>;
  companyContactPersonLastName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  individualId: Scalars['String'];
  kGolfAccountCreationError?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  memberStatus?: Maybe<MemberStatus>;
  membershipId: Scalars['String'];
  membershipType?: Maybe<MembershipTypeBasic>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type MemberCreateBookingInput = {
  bookingType?: InputMaybe<BookingType>;
  clubhouseCode?: InputMaybe<Scalars['String']>;
  coachId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  fieldLessonDetails?: InputMaybe<Scalars['String']>;
  fieldLessonVenue?: InputMaybe<Scalars['String']>;
  gameType?: InputMaybe<GameType>;
  indoorLocation?: InputMaybe<IndoorLocation>;
  isSameDay?: InputMaybe<Scalars['Boolean']>;
  memberUuid?: InputMaybe<Scalars['String']>;
  nextHour?: InputMaybe<Scalars['String']>;
  noOfPlayers?: InputMaybe<Scalars['Int']>;
  slots?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startTime?: InputMaybe<Scalars['Int']>;
};

export type MemberCreditTransactionsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type MemberDeleteRefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type MemberFindMember = {
  __typename?: 'MemberFindMember';
  memberFound: Scalars['Boolean'];
  memberName?: Maybe<Scalars['String']>;
};

export type MemberFindMemberInput = {
  targetMemberCardId: Scalars['String'];
};

export type MemberForgotPassword = {
  __typename?: 'MemberForgotPassword';
  email: Scalars['String'];
  resetToken: Scalars['String'];
};

export type MemberForgotPasswordInput = {
  email: Scalars['String'];
};

export type MemberForgotPasswordSubmitInput = {
  confirmPassword: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
  resetToken: Scalars['String'];
  verificationCode: Scalars['String'];
};

export type MemberFreeLessonsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type MemberJwtAccessToken = {
  __typename?: 'MemberJwtAccessToken';
  id?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type MemberJwtRefreshToken = {
  __typename?: 'MemberJwtRefreshToken';
  family?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  mode?: Maybe<MemberJwtRefreshTokenMode>;
  username?: Maybe<Scalars['String']>;
};

export enum MemberJwtRefreshTokenMode {
  Lt = 'LT',
  St = 'ST'
}

export type MemberLoginInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  email: Scalars['String'];
  mode: MemberRefreshTokenMode;
  password: Scalars['String'];
};

export type MemberLogoutInput = {
  refreshToken: Scalars['String'];
};

export type MemberRefreshAccessTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  mode: MemberRefreshTokenMode;
  refreshToken: Scalars['String'];
};

export enum MemberRefreshTokenMode {
  AppWithoutBiometrics = 'APP_WITHOUT_BIOMETRICS',
  AppWithBiometrics = 'APP_WITH_BIOMETRICS',
  Web = 'WEB'
}

export type MemberRemovePushTokenInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  pushToken: Scalars['String'];
};

export type MemberScoreCardArgs = {
  roundIdx: Scalars['Int'];
};

export type MemberScoreCards = {
  __typename?: 'MemberScoreCards';
  cdn: Scalars['String'];
  list: Array<Maybe<ScoreCard>>;
  totalCount: Scalars['Int'];
};

export type MemberScoreCardsArgs = {
  temp?: InputMaybe<Scalars['String']>;
};

export type MemberSimulatorPrivilege = {
  __typename?: 'MemberSimulatorPrivilege';
  hasPrivilege: Scalars['Boolean'];
  lastSimulatorUsageDate?: Maybe<Scalars['DateTime']>;
};

export enum MemberStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING'
}

export type MemberTopUpCreditInput = {
  audit?: InputMaybe<MemberAuditDataInput>;
  creditAmount: Scalars['Float'];
};

export type MemberTransferCreditInput = {
  creditAmount: Scalars['Float'];
  targetMemberCardId: Scalars['String'];
};

export type MemberUpdateEmailInput = {
  email: Scalars['String'];
};

export type MemberUpdateGenderInput = {
  gender: Gender;
};

export type MemberUpdateHandedInput = {
  handed: Handed;
};

export type MemberUpdateMobileNumberInput = {
  countryCode: Scalars['String'];
  number: Scalars['String'];
};

export type MemberUpdateNicknameInput = {
  nickname: Scalars['String'];
};

export type MemberUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export enum MembershipStatus {
  Active = 'ACTIVE',
  Lapsed = 'LAPSED',
  Pending = 'PENDING'
}

export type MembershipTypeBasic = {
  __typename?: 'MembershipTypeBasic';
  internalName?: Maybe<Scalars['String']>;
  isCorporate?: Maybe<Scalars['Boolean']>;
  tagBgColorCode?: Maybe<Scalars['String']>;
  tagText?: Maybe<Scalars['String']>;
  tagTextColorCode?: Maybe<Scalars['String']>;
};

export enum MembershipTypeTier {
  Lifestyle = 'LIFESTYLE',
  Premium = 'PREMIUM',
  Vip = 'VIP'
}

export type Mutation = {
  __typename?: 'Mutation';
  adminActivateMembership: AdminActivateMembership;
  adminBookingCancel: SystemOperationStatus;
  adminBookingSendCancellationNotification: SystemOperationStatus;
  adminClientLoginGuest: SystemOperationStatus;
  adminClientSetup: SystemOperationStatus;
  adminCreateAdmin: NewAdmin;
  adminCreateMembership: AdminNewMembership;
  adminDeleteAdmin: SystemOperationStatus;
  adminDeleteCoach: SystemOperationStatus;
  adminDeleteMembership: SystemOperationStatus;
  adminExtendClientTime: SystemOperationStatus;
  adminForgotPassword: AdminForgotPasswordResponse;
  adminForgotPasswordSubmit: SystemOperationStatus;
  adminLockClient: SystemOperationStatus;
  adminLogin: AdminAuthResponse;
  adminLogout: SystemOperationStatus;
  adminPaySubscriptions: SystemOperationStatus;
  adminRefreshAccessToken: AdminAuthResponse;
  adminReportUpdateOrderConnection: SystemOperationStatus;
  adminResendOnboardingEmail: SystemOperationStatus;
  adminShopTokens: ShopsTokens;
  adminTerminateMembership: SystemOperationStatus;
  adminUnlockClient: SystemOperationStatus;
  adminUpdateAdmin: UpdatedAdmin;
  adminUpdateClientContentLimit: SystemOperationStatus;
  adminUpdateCredit: SystemOperationStatus;
  adminUpdateFacility: SystemOperationStatus;
  adminUpdateLessonVoucher: SystemOperationStatus;
  adminUpdateMember: AdminUpdateMember;
  adminUpdateMembershipType: AdminMembershipType;
  adminUpdateNickname: SystemOperationStatus;
  adminUpdateOrganization: Organization;
  adminUpdatePricing: Pricing;
  adminUpdateReservedId: AdminUpdateReservedId;
  adminUpdateShopDetails: AdminShopDetails;
  adminUpdateShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminUpdateShopOptionsRealTime: AdminShopOptionsRealTime;
  adminUpdateShopOptionsRound: AdminShopOptionsRound;
  adminUpdateSidasInsoles: SystemOperationStatus;
  adminUpdateSubscription: SystemOperationStatus;
  coachUpsertDayAvailability: Scalars['String'];
  devEMenuImportOrders: SystemOperationStatus;
  devEMenuMatchOrders: DevEMenuMatchOrders;
  devEMenuUpsertCreditTransactions: SystemOperationStatus;
  devKGolfMemberJoin: DevKGolfMemberJoin;
  devKGolfMemberLogin: KGolfMemberLogin;
  devKGolfShopLogin: KGolfShopLogin;
  devMemberMigrationCreditTransactions: DevMemberMigrationCreditTransactions;
  devMemberMigrationGender: DevMemberMigrationGender;
  devMemberMigrationLessonVouchers: DevMemberMigrationLessonVouchers;
  devMemberMigrationLoginId: DevMemberMigrationLoginId;
  devMemberMigrationMembershipType: DevMemberMigrationMembershipType;
  devMemberMigrationNickname: DevMemberMigrationNickname;
  devMemberMigrationStartDate: DevMemberMigrationStartDate;
  devMemberMigrationSubscriptions: DevMemberMigrationSubscriptions;
  devOrgSeedItems: SystemOperationStatus;
  devUserMigrationLastAccessTokenDate: SystemOperationStatus;
  devUtilityMutation: SystemOperationStatus;
  gameMutation?: Maybe<Scalars['String']>;
  legacyCreateCoachDayAvailability: LegacyCreateCoachDayAvailability;
  legacyCreateCoachSavedSlots: Scalars['String'];
  memberAddPushToken: SystemOperationStatus;
  memberCreateBooking: SystemOperationStatus;
  memberDeleteRefreshToken: SystemOperationStatus;
  memberFindMember: MemberFindMember;
  memberForgotPassword: MemberForgotPassword;
  memberForgotPasswordSubmit: SystemOperationStatus;
  memberLogin: MemberAuthResponse;
  memberLogout: SystemOperationStatus;
  memberRefreshAccessToken: MemberAuthResponse;
  memberRemovePushToken: SystemOperationStatus;
  memberTopUpCredit: HitPayPaymentRequest;
  memberTransferCredit: SystemOperationStatus;
  memberUpdateEmail: SystemOperationStatus;
  memberUpdateGender: SystemOperationStatus;
  memberUpdateHanded: SystemOperationStatus;
  memberUpdateMobileNumber: SystemOperationStatus;
  memberUpdateNickname: SystemOperationStatus;
  memberUpdatePassword: SystemOperationStatus;
  publicContactForm: SystemOperationStatus;
  publicNewsletter: SystemOperationStatus;
  selfUpdate: SelfUpdated;
  selfUpdatePassword: SystemOperationStatus;
};


export type MutationAdminActivateMembershipArgs = {
  input?: InputMaybe<AdminActivateMembershipInput>;
};


export type MutationAdminBookingCancelArgs = {
  input: AdminBookingCancelInput;
};


export type MutationAdminBookingSendCancellationNotificationArgs = {
  input: AdminBookingSendCancellationNotificationInput;
};


export type MutationAdminClientLoginGuestArgs = {
  input: AdminClientLoginGuestInput;
};


export type MutationAdminClientSetupArgs = {
  input: AdminClientSetupInput;
};


export type MutationAdminCreateAdminArgs = {
  input: AdminCreateAdminInput;
};


export type MutationAdminCreateMembershipArgs = {
  input: AdminCreateMembershipInput;
};


export type MutationAdminDeleteAdminArgs = {
  input?: InputMaybe<AdminDeleteAdminInput>;
};


export type MutationAdminDeleteCoachArgs = {
  input?: InputMaybe<AdminDeleteCoachInput>;
};


export type MutationAdminDeleteMembershipArgs = {
  input: AdminDeleteMembershipInput;
};


export type MutationAdminExtendClientTimeArgs = {
  input: AdminExtendClientTimeInput;
};


export type MutationAdminForgotPasswordArgs = {
  input: AdminForgotPasswordInput;
};


export type MutationAdminForgotPasswordSubmitArgs = {
  input: AdminForgotPasswordSubmitInput;
};


export type MutationAdminLockClientArgs = {
  input: AdminLockClientInput;
};


export type MutationAdminLoginArgs = {
  input: AdminLoginInput;
};


export type MutationAdminPaySubscriptionsArgs = {
  input: AdminPaySubscriptionsInput;
};


export type MutationAdminReportUpdateOrderConnectionArgs = {
  input: AdminReportUpdateOrderConnectionInput;
};


export type MutationAdminResendOnboardingEmailArgs = {
  input: AdminResendOnboardingEmailInput;
};


export type MutationAdminShopTokensArgs = {
  input?: InputMaybe<AdminShopTokensInput>;
};


export type MutationAdminTerminateMembershipArgs = {
  input: AdminTerminateMembershipInput;
};


export type MutationAdminUnlockClientArgs = {
  input: AdminUnlockClientInput;
};


export type MutationAdminUpdateAdminArgs = {
  args: AdminUpdateAdminArgs;
  input: AdminUpdateAdminInput;
};


export type MutationAdminUpdateClientContentLimitArgs = {
  input: AdminUpdateClientContentLimitInput;
};


export type MutationAdminUpdateCreditArgs = {
  input?: InputMaybe<AdminUpdateCreditInput>;
};


export type MutationAdminUpdateFacilityArgs = {
  input: AdminUpdateFacilityInput;
};


export type MutationAdminUpdateLessonVoucherArgs = {
  input?: InputMaybe<AdminUpdateLessonVoucherInput>;
};


export type MutationAdminUpdateMemberArgs = {
  input: AdminUpdateMemberInput;
};


export type MutationAdminUpdateMembershipTypeArgs = {
  input: AdminUpdateMembershipTypeInput;
};


export type MutationAdminUpdateNicknameArgs = {
  input: AdminUpdateNicknameInput;
};


export type MutationAdminUpdateOrganizationArgs = {
  input: AdminUpdateOrganizationInput;
};


export type MutationAdminUpdatePricingArgs = {
  input: AdminUpdatePricingInput;
};


export type MutationAdminUpdateReservedIdArgs = {
  input?: InputMaybe<AdminUpdateReservedIdInput>;
};


export type MutationAdminUpdateShopDetailsArgs = {
  input: AdminUpdateShopDetailsInput;
};


export type MutationAdminUpdateShopOptionsDrivingRangeArgs = {
  input: AdminUpdateShopOptionsDrivingRangeInput;
};


export type MutationAdminUpdateShopOptionsRealTimeArgs = {
  input: AdminUpdateShopOptionsRealTimeInput;
};


export type MutationAdminUpdateShopOptionsRoundArgs = {
  input: AdminUpdateShopOptionsRoundInput;
};


export type MutationAdminUpdateSidasInsolesArgs = {
  input: AdminUpdateSidasInsolesInput;
};


export type MutationAdminUpdateSubscriptionArgs = {
  input: AdmnUpdateSubscriptionInput;
};


export type MutationCoachUpsertDayAvailabilityArgs = {
  input: CoachUpsertDayAvailabilityInput;
};


export type MutationDevEMenuImportOrdersArgs = {
  input: DevEMenuImportOrdersInput;
};


export type MutationDevEMenuMatchOrdersArgs = {
  input: DevEMenuMatchOrdersInput;
};


export type MutationDevEMenuUpsertCreditTransactionsArgs = {
  input?: InputMaybe<DevEMenuUpsertCreditTransactionsInput>;
};


export type MutationDevMemberMigrationCreditTransactionsArgs = {
  input: DevMemberMigrationCreditTransactionsInput;
};


export type MutationDevMemberMigrationGenderArgs = {
  input: DevMemberMigrationGenderInput;
};


export type MutationDevMemberMigrationLessonVouchersArgs = {
  input: DevMemberMigrationLessonVouchersInput;
};


export type MutationDevMemberMigrationLoginIdArgs = {
  input: DevMemberMigrationLoginIdInput;
};


export type MutationDevMemberMigrationMembershipTypeArgs = {
  input: DevMemberMigrationMembershipTypeInput;
};


export type MutationDevMemberMigrationNicknameArgs = {
  input: DevMemberMigrationNicknameInput;
};


export type MutationDevMemberMigrationStartDateArgs = {
  input: DevMemberMigrationStartDateInput;
};


export type MutationDevMemberMigrationSubscriptionsArgs = {
  input: DevMemberMigrationSubscriptionsInput;
};


export type MutationDevUserMigrationLastAccessTokenDateArgs = {
  input: DevUserMigrationLastAccessTokenDateInput;
};


export type MutationLegacyCreateCoachDayAvailabilityArgs = {
  input: LegacyCreateCoachDayAvailabilityInput;
};


export type MutationLegacyCreateCoachSavedSlotsArgs = {
  input: LegacyCreateCoachSavedSlotsInput;
};


export type MutationMemberAddPushTokenArgs = {
  input: MemberAddPushTokenInput;
};


export type MutationMemberCreateBookingArgs = {
  input: MemberCreateBookingInput;
};


export type MutationMemberDeleteRefreshTokenArgs = {
  input: MemberDeleteRefreshTokenInput;
};


export type MutationMemberFindMemberArgs = {
  input?: InputMaybe<MemberFindMemberInput>;
};


export type MutationMemberForgotPasswordArgs = {
  input: MemberForgotPasswordInput;
};


export type MutationMemberForgotPasswordSubmitArgs = {
  input: MemberForgotPasswordSubmitInput;
};


export type MutationMemberLoginArgs = {
  input: MemberLoginInput;
};


export type MutationMemberLogoutArgs = {
  input: MemberLogoutInput;
};


export type MutationMemberRefreshAccessTokenArgs = {
  input: MemberRefreshAccessTokenInput;
};


export type MutationMemberRemovePushTokenArgs = {
  input: MemberRemovePushTokenInput;
};


export type MutationMemberTopUpCreditArgs = {
  input: MemberTopUpCreditInput;
};


export type MutationMemberTransferCreditArgs = {
  input: MemberTransferCreditInput;
};


export type MutationMemberUpdateEmailArgs = {
  input: MemberUpdateEmailInput;
};


export type MutationMemberUpdateGenderArgs = {
  input: MemberUpdateGenderInput;
};


export type MutationMemberUpdateHandedArgs = {
  input: MemberUpdateHandedInput;
};


export type MutationMemberUpdateMobileNumberArgs = {
  input: MemberUpdateMobileNumberInput;
};


export type MutationMemberUpdateNicknameArgs = {
  input: MemberUpdateNicknameInput;
};


export type MutationMemberUpdatePasswordArgs = {
  input: MemberUpdatePasswordInput;
};


export type MutationPublicContactFormArgs = {
  input: PublicContactFormInput;
};


export type MutationPublicNewsletterArgs = {
  input: PublicNewsletterInput;
};


export type MutationSelfUpdateArgs = {
  input: SelfUpdateInput;
};


export type MutationSelfUpdatePasswordArgs = {
  input: SelfUpdatePasswordInput;
};

export type NewAdmin = {
  __typename?: 'NewAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type NewCoach = {
  __typename?: 'NewCoach';
  coach: Coach;
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
};

export enum OperationActorType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  System = 'SYSTEM'
}

export type Order = {
  __typename?: 'Order';
  additionalDiscount?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  discountPercent?: Maybe<Scalars['Float']>;
  eMenuCustomerName?: Maybe<Scalars['String']>;
  eMenuMemberCardNo?: Maybe<Scalars['String']>;
  gst?: Maybe<Scalars['Float']>;
  isEMenuOrder?: Maybe<Scalars['Boolean']>;
  lineItems: Array<Maybe<LineItem>>;
  memberDiscount?: Maybe<Scalars['Float']>;
  memberId?: Maybe<Scalars['String']>;
  memberIndividualId?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  membershipId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  nonMemberCustomer?: Maybe<Scalars['Boolean']>;
  orderNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: PaymentMethod;
  serviceCharge?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  venue?: Maybe<Scalars['String']>;
};

export type OrderBasic = {
  __typename?: 'OrderBasic';
  date: Scalars['DateTime'];
  eMenuCustomerName?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  nonMemberCustomer: Scalars['Boolean'];
  orderNo: Scalars['String'];
  paymentCurrency?: Maybe<PaymentCurrency>;
  paymentMethod: PaymentMethod;
  status: PaymentStatus;
  subTotal: Scalars['Float'];
  total: Scalars['Float'];
  venue?: Maybe<Scalars['String']>;
};

export type OrderBy = {
  direction?: InputMaybe<Direction>;
  field?: InputMaybe<Scalars['String']>;
};

export enum OrderMetadaProvider {
  Emenu = 'EMENU'
}

export type OrderMetadata = {
  __typename?: 'OrderMetadata';
  eMenuCustomerName?: Maybe<Scalars['String']>;
  eMenuMemberCardNo?: Maybe<Scalars['String']>;
  provider?: Maybe<OrderMetadaProvider>;
};

export type Organization = {
  __typename?: 'Organization';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  clubhouses?: Maybe<Array<Maybe<AdminClubhouse>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  organizationNumber?: Maybe<Scalars['Int']>;
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Admin>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export enum PaymentCode {
  CreditTopUp = 'CREDIT_TOP_UP',
  SignUp = 'SIGN_UP'
}

export enum PaymentCurrency {
  Sgd = 'SGD',
  Vnd = 'VND'
}

export enum PaymentMethod {
  Acecoins = 'ACECOINS',
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD',
  Hitpay = 'HITPAY',
  Nets = 'NETS',
  Nil = 'NIL',
  Paynow = 'PAYNOW'
}

export enum PaymentMode {
  BankTransfer = 'BANK_TRANSFER',
  Emenu = 'EMENU',
  Hitpay = 'HITPAY',
  Nil = 'NIL'
}

export enum PaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type Pricing = {
  __typename?: 'Pricing';
  sgBayHourlyRate?: Maybe<Scalars['Int']>;
  sgBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgBayMaxHours?: Maybe<Scalars['Int']>;
  sgBayMaxPlayers?: Maybe<Scalars['Int']>;
  sgBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  sgBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  sgHole9MaxHours?: Maybe<Scalars['Int']>;
  sgHole9MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgHole18MaxHours?: Maybe<Scalars['Int']>;
  sgHole18MaxPlayers?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  sgHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  sgLessonField?: Maybe<Scalars['Int']>;
  sgLessonFieldVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoor?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  sgLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  sgLessonIndoorVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  sgPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  sgPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  sgPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  sgPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
  viBayHourlyRate?: Maybe<Scalars['Int']>;
  viBayHourlyRateVIP?: Maybe<Scalars['Int']>;
  viBayMaxHours?: Maybe<Scalars['Int']>;
  viBayMaxPlayers?: Maybe<Scalars['Int']>;
  viBookingCancellationPenalty?: Maybe<Scalars['Int']>;
  viBookingLapsedPenalty?: Maybe<Scalars['Int']>;
  viHole9MaxHours?: Maybe<Scalars['Int']>;
  viHole9MaxPlayers?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole9PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viHole18MaxHours?: Maybe<Scalars['Int']>;
  viHole18MaxPlayers?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRate?: Maybe<Scalars['Int']>;
  viHole18PerPlayerRateVIP?: Maybe<Scalars['Int']>;
  viLessonField?: Maybe<Scalars['Int']>;
  viLessonFieldVIP?: Maybe<Scalars['Int']>;
  viLessonIndoor?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreen?: Maybe<Scalars['Int']>;
  viLessonIndoorPuttingGreenVIP?: Maybe<Scalars['Int']>;
  viLessonIndoorVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRate?: Maybe<Scalars['Int']>;
  viPrivateRoomHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxHours?: Maybe<Scalars['Int']>;
  viPrivateRoomMaxPlayers?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRate?: Maybe<Scalars['Int']>;
  viPuttingGreenHourlyRateVIP?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxMins?: Maybe<Scalars['Int']>;
  viPuttingGreenMaxPlayers?: Maybe<Scalars['Int']>;
};

export type PrivateRoom = {
  __typename?: 'PrivateRoom';
  blockedFromBooking: Scalars['Boolean'];
  clientname: Scalars['String'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PublicContactFormInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PublicMembership = {
  __typename?: 'PublicMembership';
  exampleField?: Maybe<Scalars['Int']>;
};

export type PublicNewsletterInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type PuttingGreen = {
  __typename?: 'PuttingGreen';
  blockedFromBooking: Scalars['Boolean'];
  clubhouseId: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  admin?: Maybe<Admin>;
  adminBooking?: Maybe<AdminBooking>;
  adminBookingAvailability: Scalars['String'];
  adminBookings: AdminBookingResponse;
  adminClientStatus: ClientStatus;
  adminClubhouse: AdminClubhouse;
  adminClubhouseFacilities: Array<Facility>;
  adminClubhouses: AdminClubhouseResponse;
  adminCoaches: AdminCoachResponse;
  adminCreditTransactions: AdminCreditTransactionResponse;
  adminGameHistory: AdminGameHistory;
  adminKGolfMember: AdminKGolfMember;
  adminLessonVouchers: AdminLessonVoucherResponse;
  adminMember: AdminMember;
  adminMemberSubscriptions: AdminMemberSubscriptionResponse;
  adminMembers: AdminMemberResponse;
  adminMembershipSubscriptions: AdminMembershipSubscriptionResponse;
  adminMembershipType: AdminMembershipType;
  adminMembershipTypes: AdminMembershipTypes;
  adminReportCreditTransactions: AdminReportCreditTransactionResponse;
  adminReportLessonVouchers: AdminReportLessonVoucherResponse;
  adminReportMemberStats: AdminReportMemberStatResponse;
  adminReportOrder: Order;
  adminReportOrders: AdminReportOrderResponse;
  adminReportSubscriptions: AdminReportSubscriptionResponse;
  adminReservedIds?: Maybe<AdminReservedIds>;
  adminScoreCard?: Maybe<Scalars['JSON']>;
  adminShopDetails?: Maybe<AdminShopDetails>;
  adminShopOptionsDrivingRange: AdminShopOptionsDrivingRange;
  adminShopOptionsRealTime: AdminShopOptionsRealTime;
  adminShopOptionsRound: AdminShopOptionsRound;
  adminSimulatorUsage?: Maybe<Scalars['JSON']>;
  adminStaffs: AdminStaffResponse;
  admins: AdminResponse;
  appDineMenu?: Maybe<AppDineMenu>;
  appMainSlider?: Maybe<AppMainSlider>;
  coachBookings: CoachBookingResponse;
  coachCalendarAvailabilities: Array<Maybe<CoachCalendarAvailability>>;
  coachDayAvailability?: Maybe<CoachDayAvailability>;
  devAnalyticsCreditTransactions: DevAnalyticsCreditTransactions;
  devKGolfMemberGet: KGolfMemberGet;
  devUtilityEnvs: DevUtilityEnvs;
  formHelperBooking?: Maybe<FormHelperBooking>;
  formHelperNewAdmin?: Maybe<FormHelperNewAdmin>;
  formHelperNewCoach?: Maybe<FormHelperNewCoach>;
  formHelperNewMembership?: Maybe<FormHelperNewMembership>;
  legacyCoachAvailabilities?: Maybe<Array<Maybe<LegacyCoachAvailability>>>;
  legacyCoachDayBookings?: Maybe<LegacyCoachDayBookings>;
  legacySelfAsCoach?: Maybe<LegacyCoach>;
  memberAccount: MemberAccount;
  memberCoachesForPublic?: Maybe<Array<Maybe<CoachForPublic>>>;
  memberCreditTransactions: Array<Maybe<CreditTransaction>>;
  memberFreeLessons: Array<Maybe<FreeLesson>>;
  memberScoreCard: Scalars['JSON'];
  memberScoreCards: Scalars['JSON'];
  memberSimulatorPrivilege: MemberSimulatorPrivilege;
  organization?: Maybe<Organization>;
  pricing?: Maybe<Pricing>;
  publicCoaches?: Maybe<Array<Maybe<CoachForPublic>>>;
  publicMembership: Array<Maybe<PublicMembership>>;
  self?: Maybe<Self>;
};


export type QueryAdminArgs = {
  args: AdminArgs;
};


export type QueryAdminBookingArgs = {
  args: AdminBookingArgs;
};


export type QueryAdminBookingAvailabilityArgs = {
  args: AdminBookingAvailabilityArgs;
};


export type QueryAdminBookingsArgs = {
  args: AdminBookingsArgs;
};


export type QueryAdminClientStatusArgs = {
  args: AdminClientStatusArgs;
};


export type QueryAdminClubhouseArgs = {
  args: AdminClubhouseArgs;
};


export type QueryAdminClubhouseFacilitiesArgs = {
  args: AdminClubhouseFacilitiesArgs;
};


export type QueryAdminClubhousesArgs = {
  args: AdminClubhousesArgs;
};


export type QueryAdminCoachesArgs = {
  args?: InputMaybe<AdminCoachesArgs>;
};


export type QueryAdminCreditTransactionsArgs = {
  args: AdminCreditTransactionsArgs;
};


export type QueryAdminGameHistoryArgs = {
  args: AdminGameHistoryArgs;
};


export type QueryAdminKGolfMemberArgs = {
  args?: InputMaybe<AdminKGolfMemberArgs>;
};


export type QueryAdminLessonVouchersArgs = {
  args: AdminLessonVouchersArgs;
};


export type QueryAdminMemberArgs = {
  args: AdminMemberArgs;
};


export type QueryAdminMemberSubscriptionsArgs = {
  args: AdminMemberSubscriptionsArgs;
};


export type QueryAdminMembersArgs = {
  args: AdminMembersArgs;
};


export type QueryAdminMembershipSubscriptionsArgs = {
  args: AdminMembershipSubscriptionsArgs;
};


export type QueryAdminMembershipTypeArgs = {
  args: AdminMembershipTypeArgs;
};


export type QueryAdminMembershipTypesArgs = {
  args: AdminMembershipTypesArgs;
};


export type QueryAdminReportCreditTransactionsArgs = {
  args: AdminReportCreditTransactionsArgs;
};


export type QueryAdminReportLessonVouchersArgs = {
  args: AdminReportLessonVouchersArgs;
};


export type QueryAdminReportMemberStatsArgs = {
  args: AdminReportMemberStatsArgs;
};


export type QueryAdminReportOrderArgs = {
  args: AdminReportOrderArgs;
};


export type QueryAdminReportOrdersArgs = {
  args: AdminReportOrdersArgs;
};


export type QueryAdminReportSubscriptionsArgs = {
  args: AdminReportSubscriptionsArgs;
};


export type QueryAdminReservedIdsArgs = {
  args?: InputMaybe<AdminReservedIdsArgs>;
};


export type QueryAdminScoreCardArgs = {
  args: AdminScoreCardArgs;
};


export type QueryAdminShopDetailsArgs = {
  args: AdminShopDetailsArg;
};


export type QueryAdminShopOptionsDrivingRangeArgs = {
  args: AdminShopOptionsDrivingRangeArgs;
};


export type QueryAdminShopOptionsRealTimeArgs = {
  args: AdminShopOptionsRealTimeArgs;
};


export type QueryAdminShopOptionsRoundArgs = {
  args: AdminShopOptionsRoundArgs;
};


export type QueryAdminSimulatorUsageArgs = {
  args: AdminSimulatorUsageArgs;
};


export type QueryAdminStaffsArgs = {
  args?: InputMaybe<AdminStaffsArgs>;
};


export type QueryAdminsArgs = {
  args: AdminsArgs;
};


export type QueryAppDineMenuArgs = {
  args?: InputMaybe<AppDineMenuArgs>;
};


export type QueryAppMainSliderArgs = {
  args?: InputMaybe<AppMainSliderArgs>;
};


export type QueryCoachBookingsArgs = {
  args: CoachBookingsArgs;
};


export type QueryCoachDayAvailabilityArgs = {
  args: CoachDayAvailabilityArgs;
};


export type QueryFormHelperBookingArgs = {
  args: FormHelperBookingArgs;
};


export type QueryFormHelperNewAdminArgs = {
  args: FormHelperNewAdminArgs;
};


export type QueryFormHelperNewCoachArgs = {
  args: FormHelperNewCoachArgs;
};


export type QueryFormHelperNewMembershipArgs = {
  args: FormHelperNewMembershipArgs;
};


export type QueryLegacyCoachAvailabilitiesArgs = {
  userId: Scalars['String'];
};


export type QueryLegacyCoachDayBookingsArgs = {
  input: LegacyCoachDayBookingsInput;
};


export type QueryMemberCreditTransactionsArgs = {
  args: MemberCreditTransactionsArgs;
};


export type QueryMemberFreeLessonsArgs = {
  args: MemberFreeLessonsArgs;
};


export type QueryMemberScoreCardArgs = {
  args: MemberScoreCardArgs;
};


export type QueryMemberScoreCardsArgs = {
  args: MemberScoreCardsArgs;
};

export enum Relationship {
  Child = 'CHILD',
  Spouse = 'SPOUSE'
}

export enum ReservedIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export enum ReservedMembershipIdStatus {
  Assigned = 'ASSIGNED',
  Available = 'AVAILABLE',
  OnHold = 'ON_HOLD'
}

export type ScoreCard = {
  __typename?: 'ScoreCard';
  clientName: Scalars['String'];
  courseIntroImage: Scalars['String'];
  courseLogoImage: Scalars['String'];
  courseName: Scalars['String'];
  endTime: Scalars['Int'];
  gameType: Scalars['Int'];
  gameTypeText: Scalars['String'];
  roundIdx: Scalars['Int'];
  shopName: Scalars['String'];
  startTime: Scalars['Int'];
  strokeTotalScore: Scalars['Int'];
};

export type Self = {
  __typename?: 'Self';
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins: Array<Maybe<LoginInfo>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export type SelfUpdateInput = {
  deleteImage?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  profileImageFile?: InputMaybe<File>;
};

export type SelfUpdatePasswordInput = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SelfUpdated = {
  __typename?: 'SelfUpdated';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  self: Self;
};

export enum SentBy {
  Admin = 'ADMIN',
  Coach = 'COACH',
  System = 'SYSTEM'
}

export type ShopTokens = {
  __typename?: 'ShopTokens';
  clubhouseCode: Scalars['String'];
  clubhouseName: Scalars['String'];
  kgat: Scalars['String'];
  kgrt: Scalars['String'];
  shopGuid: Scalars['String'];
  shopName: Scalars['String'];
};

export type ShopsTokens = {
  __typename?: 'ShopsTokens';
  expires: Scalars['String'];
  shops?: Maybe<Scalars['JSON']>;
  ud?: Maybe<Scalars['DateTime']>;
};

export enum StringBoolean {
  False = 'FALSE',
  True = 'TRUE'
}

export type Subscription = {
  __typename?: 'Subscription';
  managementSystem?: Maybe<ManagementSystem>;
  memberApp?: Maybe<MemberApp>;
};


export type SubscriptionMemberAppArgs = {
  args: MemberAppArgs;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Na = 'NA',
  Paused = 'PAUSED',
  Pending = 'PENDING'
}

export enum SystemOperationStatus {
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  AdminNotFound = 'ADMIN_NOT_FOUND',
  BadRequestException = 'BAD_REQUEST_EXCEPTION',
  CannotFindSelf = 'CANNOT_FIND_SELF',
  Fail = 'FAIL',
  IncorrectExistingPassword = 'INCORRECT_EXISTING_PASSWORD',
  InsufficientCredit = 'INSUFFICIENT_CREDIT',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  MemberNotFound = 'MEMBER_NOT_FOUND',
  MemberNotFoundPasswordReset = 'MEMBER_NOT_FOUND_PASSWORD_RESET',
  NoRefreshToken = 'NO_REFRESH_TOKEN',
  PasswordMismatch = 'PASSWORD_MISMATCH',
  ResourceNotAvailable = 'RESOURCE_NOT_AVAILABLE',
  Success = 'SUCCESS',
  SuccessPasswordUpdate = 'SUCCESS_PASSWORD_UPDATE',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  UnableToUpdate = 'UNABLE_TO_UPDATE',
  Unauthorized = 'UNAUTHORIZED',
  UniqueConstraintEmail = 'UNIQUE_CONSTRAINT_EMAIL',
  UniqueConstraintViolation = 'UNIQUE_CONSTRAINT_VIOLATION',
  VerificationCodeMismatch = 'VERIFICATION_CODE_MISMATCH'
}

export type SystemUser = {
  baseCountryCode?: Maybe<CountryCode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastLogin?: Maybe<LoginInfo>;
  lastName: Scalars['String'];
  logins?: Maybe<Array<Maybe<LoginInfo>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  organization?: Maybe<AdminOrganization>;
  profileImageUrl?: Maybe<Scalars['String']>;
  status?: Maybe<AdminStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['String'];
  userType?: Maybe<UserType>;
};

export enum TransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type UpdatedAdmin = {
  __typename?: 'UpdatedAdmin';
  fileUploadCredentials?: Maybe<FileUploadCredentials>;
  user: Admin;
};

export type UserOrganization = {
  __typename?: 'UserOrganization';
  businessName: Scalars['String'];
  clubhouses?: Maybe<Array<Maybe<BasicClubhouseDetails>>>;
  emailDomains: Array<Scalars['String']>;
  id: Scalars['String'];
};

export enum UserType {
  ClubhouseStaff = 'CLUBHOUSE_STAFF',
  Developer = 'DEVELOPER',
  ExternalCoach = 'EXTERNAL_COACH',
  MasterCoach = 'MASTER_COACH',
  MasterOwner = 'MASTER_OWNER',
  MasterUser = 'MASTER_USER',
  Owner = 'OWNER',
  User = 'USER'
}

export type ManagementSystemSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ManagementSystemSubscription = { __typename?: 'Subscription', managementSystem?: { __typename?: 'ManagementSystem', eventId: string, operation?: ManagementSystemPublishOperation | null, userId?: string | null, userName?: string | null, userProfileImageUrl?: string | null } | null };

export type CoachUpsertDayAvailabilityMutationVariables = Exact<{
  input: CoachUpsertDayAvailabilityInput;
}>;


export type CoachUpsertDayAvailabilityMutation = { __typename?: 'Mutation', coachUpsertDayAvailability: string };

export type CoachCalendarAvailabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachCalendarAvailabilitiesQuery = { __typename?: 'Query', coachCalendarAvailabilities: Array<{ __typename?: 'CoachCalendarAvailability', clubhouses: Array<string | null>, date: string } | null> };

export type CoachDayAvailabilityQueryVariables = Exact<{
  args: CoachDayAvailabilityArgs;
}>;


export type CoachDayAvailabilityQuery = { __typename?: 'Query', coachDayAvailability?: { __typename?: 'CoachDayAvailability', b0800?: string | null, b0900?: string | null, b1000?: string | null, b1100?: string | null, b1200?: string | null, b1300?: string | null, b1400?: string | null, b1500?: string | null, b1600?: string | null, b1700?: string | null, b1800?: string | null, b1900?: string | null, b2000?: string | null, b2100?: string | null, b2200?: string | null, b2300?: string | null, date?: string | null, l0800?: string | null, l0900?: string | null, l1000?: string | null, l1100?: string | null, l1200?: string | null, l1300?: string | null, l1400?: string | null, l1500?: string | null, l1600?: string | null, l1700?: string | null, l1800?: string | null, l1900?: string | null, l2000?: string | null, l2100?: string | null, l2200?: string | null, l2300?: string | null } | null };

export type AdminBookingCancelMutationVariables = Exact<{
  input: AdminBookingCancelInput;
}>;


export type AdminBookingCancelMutation = { __typename?: 'Mutation', adminBookingCancel: SystemOperationStatus };

export type AdminBookingSendCancellationNotificationMutationVariables = Exact<{
  input: AdminBookingSendCancellationNotificationInput;
}>;


export type AdminBookingSendCancellationNotificationMutation = { __typename?: 'Mutation', adminBookingSendCancellationNotification: SystemOperationStatus };

export type CoachBookingsQueryVariables = Exact<{
  args: CoachBookingsArgs;
}>;


export type CoachBookingsQuery = { __typename?: 'Query', coachBookings: { __typename?: 'CoachBookingResponse', edges?: Array<{ __typename?: 'CoachBookingEdge', cursor?: string | null, node?: { __typename?: 'CoachBookingBasic', cancellationDateTime?: any | null, date: any, endTime: any, id: string, resourceName?: string | null, startTime: any, status: BookingStatus, type: BookingType, venue?: string | null, member: { __typename?: 'AdminBookingBasicMember', firstName?: string | null, lastName?: string | null } } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type FormHelperBookingQueryVariables = Exact<{
  args: FormHelperBookingArgs;
}>;


export type FormHelperBookingQuery = { __typename?: 'Query', formHelperBooking?: { __typename?: 'FormHelperBooking', clubhouses: Array<{ __typename?: 'AdminClubhouseBasic', clubhouseCode: string, clubhouseId: string, name: string } | null> } | null };

export type AdminBookingAvailabilityQueryVariables = Exact<{
  args: AdminBookingAvailabilityArgs;
}>;


export type AdminBookingAvailabilityQuery = { __typename?: 'Query', adminBookingAvailability: string };

export type AdminBookingQueryVariables = Exact<{
  args: AdminBookingArgs;
}>;


export type AdminBookingQuery = { __typename?: 'Query', adminBooking?: { __typename?: 'AdminBooking', cancellationDateTime?: any | null, cancellationNotificationByAppSent?: boolean | null, cancellationNotificationByEmailSent?: boolean | null, cancellationNotificationBySmsSent?: boolean | null, cancellationNotificationMessage?: string | null, cancellationNotificationSentByAdminName?: string | null, cancellationNotificationSentDateTime?: any | null, cancellationReason?: string | null, cancelledBy?: CancelledBy | null, cancelledByAdminName?: string | null, coachId?: string | null, coachName?: string | null, createdAt: any, createdBy?: CreatedBy | null, createdByAdminName?: string | null, date: any, duration?: number | null, endTime: any, fieldLessonDetails?: string | null, gameCourseType?: GameCourseType | null, id: string, member: string, memberIndividualId: string, memberUuid: string, noOfPlayers: number, resourceName?: string | null, startTime: any, status: BookingStatus, type: BookingType, venue?: string | null } | null };

export type AdminBookingsQueryVariables = Exact<{
  args: AdminBookingsArgs;
}>;


export type AdminBookingsQuery = { __typename?: 'Query', adminBookings: { __typename?: 'AdminBookingResponse', edges?: Array<{ __typename?: 'AdminBookingEdge', cursor?: string | null, node?: { __typename?: 'AdminBookingBasic', cancellationDateTime?: any | null, date: any, endTime: any, id: string, resourceName?: string | null, startTime: any, status: BookingStatus, type: BookingType, venue?: string | null, member: { __typename?: 'AdminBookingBasicMember', firstName?: string | null, lastName?: string | null } } | null } | null> | null, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, total?: number | null } | null } };

export type AdminLoginMutationVariables = Exact<{
  input: AdminLoginInput;
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminLogoutMutation = { __typename?: 'Mutation', adminLogout: SystemOperationStatus };

export type AdminRefreshAccessTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type AdminRefreshAccessTokenMutation = { __typename?: 'Mutation', adminRefreshAccessToken: { __typename?: 'AdminAuthResponse', accessToken: string, authenticatedAdmin: { __typename?: 'AuthenticatedAdmin', clubhouseCode?: string | null, clubhouses: Array<string | null>, firstName: string, lastLoginDate?: any | null, lastName: string, permissions?: Array<string | null> | null, profileImageUrl: string, ud?: any | null, userId: string, userType: string, yourIp: string, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null } } };

export type AdminForgotPasswordMutationVariables = Exact<{
  input: AdminForgotPasswordInput;
}>;


export type AdminForgotPasswordMutation = { __typename?: 'Mutation', adminForgotPassword: { __typename?: 'AdminForgotPasswordResponse', email: string, resetToken: string } };

export type AdminForgotPasswordSubmitMutationVariables = Exact<{
  input: AdminForgotPasswordSubmitInput;
}>;


export type AdminForgotPasswordSubmitMutation = { __typename?: 'Mutation', adminForgotPasswordSubmit: SystemOperationStatus };

export type AdminShopTokensMutationVariables = Exact<{
  input?: InputMaybe<AdminShopTokensInput>;
}>;


export type AdminShopTokensMutation = { __typename?: 'Mutation', adminShopTokens: { __typename?: 'ShopsTokens', expires: string, shops?: any | null, ud?: any | null } };

export type SelfUpdateMutationVariables = Exact<{
  input: SelfUpdateInput;
}>;


export type SelfUpdateMutation = { __typename?: 'Mutation', selfUpdate: { __typename?: 'SelfUpdated', fileUploadCredentials?: { __typename?: 'FileUploadCredentials', fields: any, signedUrl: string } | null, self: { __typename?: 'Self', createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } } };

export type SelfUpdatePasswordMutationVariables = Exact<{
  input: SelfUpdatePasswordInput;
}>;


export type SelfUpdatePasswordMutation = { __typename?: 'Mutation', selfUpdatePassword: SystemOperationStatus };

export type SelfQueryVariables = Exact<{ [key: string]: never; }>;


export type SelfQuery = { __typename?: 'Query', self?: { __typename?: 'Self', createdAt?: any | null, email: string, firstName: string, lastName: string, mobileNumber?: string | null, organizationId: string, organizationName: string, profileImageUrl?: string | null, status?: AdminStatus | null, updatedAt?: any | null, userId: string, userType?: UserType | null, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null> } | null };

export type LegacyCreateCoachDayAvailabilityMutationVariables = Exact<{
  input: LegacyCreateCoachDayAvailabilityInput;
}>;


export type LegacyCreateCoachDayAvailabilityMutation = { __typename?: 'Mutation', legacyCreateCoachDayAvailability: { __typename?: 'LegacyCreateCoachDayAvailability', hasAvailabiliity?: boolean | null } };

export type LegacyCoachAvailabilitiesQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type LegacyCoachAvailabilitiesQuery = { __typename?: 'Query', legacyCoachAvailabilities?: Array<{ __typename?: 'LegacyCoachAvailability', blockedSlots: Array<number | null>, clubhouseCode: string, date: any, fullyBooked: boolean, hasIndoorBookings: boolean, id: string } | null> | null };

export type LegacySelfAsCoachQueryVariables = Exact<{ [key: string]: never; }>;


export type LegacySelfAsCoachQuery = { __typename?: 'Query', legacySelfAsCoach?: { __typename?: 'LegacyCoach', coachBirthdate?: string | null, coachBirthPlace?: string | null, coachExperiences?: any | null, coachExpertise?: Array<string | null> | null, coachLanguages?: Array<string | null> | null, coachLevel?: CoachLevel | null, coachListOrder?: number | null, coachPGANo?: string | null, coachPGAType?: string | null, coachPGAYear?: string | null, coachSavedSlots1?: Array<number | null> | null, coachSavedSlots2?: Array<number | null> | null, coachSavedSlots3?: Array<number | null> | null, createdAt?: any | null, displayName?: string | null, email: string, firstName: string, gender?: LegacyUserGender | null, lastName: string, mobileNumber?: string | null, profileImageUrl?: string | null, status: AdminStatus, updatedAt?: any | null, userId: string, userType: UserType, bookings: Array<{ __typename?: 'LegacyBooking', coachDisplayName?: string | null, coachId?: string | null, compFieldLessonToDeduct?: number | null, compIndoorLessonToDeduct?: number | null, creditToDeduct?: number | null, date?: any | null, details?: string | null, endTime?: any | null, id?: string | null, location?: IndoorLocation | null, profileImageUrl?: string | null, resourceName?: string | null, slots?: Array<number | null> | null, startTime?: any | null, status?: BookingStatus | null, type?: BookingType | null, userId?: string | null, venue?: string | null, member?: { __typename?: 'LegacyMember', firstName?: string | null, id?: string | null, individualId?: string | null, lastName?: string | null, membership?: { __typename?: 'LegacyMembership', id?: string | null, membershipId?: string | null } | null } | null } | null>, coachAvailabilities: Array<{ __typename?: 'LegacyCoachAvailability', blockedSlots: Array<number | null>, clubhouseCode: string, date: any, fullyBooked: boolean, hasIndoorBookings: boolean, id: string } | null>, lastLogin?: { __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null, logins: Array<{ __typename?: 'LoginInfo', city?: string | null, ipAddress?: string | null, time?: any | null } | null>, organization: { __typename?: 'LegacyUserOrganization', businessName: string, emailDomains: Array<string>, id: string } } | null };

export type LegacyCoachDayBookingsQueryVariables = Exact<{
  input: LegacyCoachDayBookingsInput;
}>;


export type LegacyCoachDayBookingsQuery = { __typename?: 'Query', legacyCoachDayBookings?: { __typename?: 'LegacyCoachDayBookings', bookedSlots?: Array<number | null> | null, hasFieldBooking?: boolean | null } | null };

export type LegacyCreateCoachSavedSlotsMutationVariables = Exact<{
  input: LegacyCreateCoachSavedSlotsInput;
}>;


export type LegacyCreateCoachSavedSlotsMutation = { __typename?: 'Mutation', legacyCreateCoachSavedSlots: string };


export const ManagementSystemDocument = gql`
    subscription ManagementSystem {
  managementSystem {
    eventId
    operation
    userId
    userName
    userProfileImageUrl
  }
}
    `;

/**
 * __useManagementSystemSubscription__
 *
 * To run a query within a React component, call `useManagementSystemSubscription` and pass it any options that fit your needs.
 * When your component renders, `useManagementSystemSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagementSystemSubscription({
 *   variables: {
 *   },
 * });
 */
export function useManagementSystemSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ManagementSystemSubscription, ManagementSystemSubscriptionVariables>(ManagementSystemDocument, options);
      }
export type ManagementSystemSubscriptionHookResult = ReturnType<typeof useManagementSystemSubscription>;
export type ManagementSystemSubscriptionResult = Apollo.SubscriptionResult<ManagementSystemSubscription>;
export const CoachUpsertDayAvailabilityDocument = gql`
    mutation CoachUpsertDayAvailability($input: CoachUpsertDayAvailabilityInput!) {
  coachUpsertDayAvailability(input: $input)
}
    `;
export type CoachUpsertDayAvailabilityMutationFn = Apollo.MutationFunction<CoachUpsertDayAvailabilityMutation, CoachUpsertDayAvailabilityMutationVariables>;

/**
 * __useCoachUpsertDayAvailabilityMutation__
 *
 * To run a mutation, you first call `useCoachUpsertDayAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachUpsertDayAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachUpsertDayAvailabilityMutation, { data, loading, error }] = useCoachUpsertDayAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachUpsertDayAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CoachUpsertDayAvailabilityMutation, CoachUpsertDayAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachUpsertDayAvailabilityMutation, CoachUpsertDayAvailabilityMutationVariables>(CoachUpsertDayAvailabilityDocument, options);
      }
export type CoachUpsertDayAvailabilityMutationHookResult = ReturnType<typeof useCoachUpsertDayAvailabilityMutation>;
export type CoachUpsertDayAvailabilityMutationResult = Apollo.MutationResult<CoachUpsertDayAvailabilityMutation>;
export type CoachUpsertDayAvailabilityMutationOptions = Apollo.BaseMutationOptions<CoachUpsertDayAvailabilityMutation, CoachUpsertDayAvailabilityMutationVariables>;
export const CoachCalendarAvailabilitiesDocument = gql`
    query CoachCalendarAvailabilities {
  coachCalendarAvailabilities {
    clubhouses
    date
  }
}
    `;

/**
 * __useCoachCalendarAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useCoachCalendarAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachCalendarAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachCalendarAvailabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachCalendarAvailabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<CoachCalendarAvailabilitiesQuery, CoachCalendarAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachCalendarAvailabilitiesQuery, CoachCalendarAvailabilitiesQueryVariables>(CoachCalendarAvailabilitiesDocument, options);
      }
export function useCoachCalendarAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachCalendarAvailabilitiesQuery, CoachCalendarAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachCalendarAvailabilitiesQuery, CoachCalendarAvailabilitiesQueryVariables>(CoachCalendarAvailabilitiesDocument, options);
        }
export type CoachCalendarAvailabilitiesQueryHookResult = ReturnType<typeof useCoachCalendarAvailabilitiesQuery>;
export type CoachCalendarAvailabilitiesLazyQueryHookResult = ReturnType<typeof useCoachCalendarAvailabilitiesLazyQuery>;
export type CoachCalendarAvailabilitiesQueryResult = Apollo.QueryResult<CoachCalendarAvailabilitiesQuery, CoachCalendarAvailabilitiesQueryVariables>;
export const CoachDayAvailabilityDocument = gql`
    query CoachDayAvailability($args: CoachDayAvailabilityArgs!) {
  coachDayAvailability(args: $args) {
    b0800
    b0900
    b1000
    b1100
    b1200
    b1300
    b1400
    b1500
    b1600
    b1700
    b1800
    b1900
    b2000
    b2100
    b2200
    b2300
    date
    l0800
    l0900
    l1000
    l1100
    l1200
    l1300
    l1400
    l1500
    l1600
    l1700
    l1800
    l1900
    l2000
    l2100
    l2200
    l2300
  }
}
    `;

/**
 * __useCoachDayAvailabilityQuery__
 *
 * To run a query within a React component, call `useCoachDayAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachDayAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachDayAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachDayAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<CoachDayAvailabilityQuery, CoachDayAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachDayAvailabilityQuery, CoachDayAvailabilityQueryVariables>(CoachDayAvailabilityDocument, options);
      }
export function useCoachDayAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachDayAvailabilityQuery, CoachDayAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachDayAvailabilityQuery, CoachDayAvailabilityQueryVariables>(CoachDayAvailabilityDocument, options);
        }
export type CoachDayAvailabilityQueryHookResult = ReturnType<typeof useCoachDayAvailabilityQuery>;
export type CoachDayAvailabilityLazyQueryHookResult = ReturnType<typeof useCoachDayAvailabilityLazyQuery>;
export type CoachDayAvailabilityQueryResult = Apollo.QueryResult<CoachDayAvailabilityQuery, CoachDayAvailabilityQueryVariables>;
export const AdminBookingCancelDocument = gql`
    mutation AdminBookingCancel($input: AdminBookingCancelInput!) {
  adminBookingCancel(input: $input)
}
    `;
export type AdminBookingCancelMutationFn = Apollo.MutationFunction<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;

/**
 * __useAdminBookingCancelMutation__
 *
 * To run a mutation, you first call `useAdminBookingCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingCancelMutation, { data, loading, error }] = useAdminBookingCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingCancelMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>(AdminBookingCancelDocument, options);
      }
export type AdminBookingCancelMutationHookResult = ReturnType<typeof useAdminBookingCancelMutation>;
export type AdminBookingCancelMutationResult = Apollo.MutationResult<AdminBookingCancelMutation>;
export type AdminBookingCancelMutationOptions = Apollo.BaseMutationOptions<AdminBookingCancelMutation, AdminBookingCancelMutationVariables>;
export const AdminBookingSendCancellationNotificationDocument = gql`
    mutation AdminBookingSendCancellationNotification($input: AdminBookingSendCancellationNotificationInput!) {
  adminBookingSendCancellationNotification(input: $input)
}
    `;
export type AdminBookingSendCancellationNotificationMutationFn = Apollo.MutationFunction<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;

/**
 * __useAdminBookingSendCancellationNotificationMutation__
 *
 * To run a mutation, you first call `useAdminBookingSendCancellationNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingSendCancellationNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBookingSendCancellationNotificationMutation, { data, loading, error }] = useAdminBookingSendCancellationNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminBookingSendCancellationNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>(AdminBookingSendCancellationNotificationDocument, options);
      }
export type AdminBookingSendCancellationNotificationMutationHookResult = ReturnType<typeof useAdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationResult = Apollo.MutationResult<AdminBookingSendCancellationNotificationMutation>;
export type AdminBookingSendCancellationNotificationMutationOptions = Apollo.BaseMutationOptions<AdminBookingSendCancellationNotificationMutation, AdminBookingSendCancellationNotificationMutationVariables>;
export const CoachBookingsDocument = gql`
    query CoachBookings($args: CoachBookingsArgs!) {
  coachBookings(args: $args) {
    edges {
      cursor
      node {
        cancellationDateTime
        date
        endTime
        id
        member {
          firstName
          lastName
        }
        resourceName
        startTime
        status
        type
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useCoachBookingsQuery__
 *
 * To run a query within a React component, call `useCoachBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBookingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCoachBookingsQuery(baseOptions: Apollo.QueryHookOptions<CoachBookingsQuery, CoachBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachBookingsQuery, CoachBookingsQueryVariables>(CoachBookingsDocument, options);
      }
export function useCoachBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachBookingsQuery, CoachBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachBookingsQuery, CoachBookingsQueryVariables>(CoachBookingsDocument, options);
        }
export type CoachBookingsQueryHookResult = ReturnType<typeof useCoachBookingsQuery>;
export type CoachBookingsLazyQueryHookResult = ReturnType<typeof useCoachBookingsLazyQuery>;
export type CoachBookingsQueryResult = Apollo.QueryResult<CoachBookingsQuery, CoachBookingsQueryVariables>;
export const FormHelperBookingDocument = gql`
    query FormHelperBooking($args: FormHelperBookingArgs!) {
  formHelperBooking(args: $args) {
    clubhouses {
      clubhouseCode
      clubhouseId
      name
    }
  }
}
    `;

/**
 * __useFormHelperBookingQuery__
 *
 * To run a query within a React component, call `useFormHelperBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormHelperBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormHelperBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useFormHelperBookingQuery(baseOptions: Apollo.QueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
      }
export function useFormHelperBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormHelperBookingQuery, FormHelperBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormHelperBookingQuery, FormHelperBookingQueryVariables>(FormHelperBookingDocument, options);
        }
export type FormHelperBookingQueryHookResult = ReturnType<typeof useFormHelperBookingQuery>;
export type FormHelperBookingLazyQueryHookResult = ReturnType<typeof useFormHelperBookingLazyQuery>;
export type FormHelperBookingQueryResult = Apollo.QueryResult<FormHelperBookingQuery, FormHelperBookingQueryVariables>;
export const AdminBookingAvailabilityDocument = gql`
    query AdminBookingAvailability($args: AdminBookingAvailabilityArgs!) {
  adminBookingAvailability(args: $args)
}
    `;

/**
 * __useAdminBookingAvailabilityQuery__
 *
 * To run a query within a React component, call `useAdminBookingAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingAvailabilityQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
      }
export function useAdminBookingAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>(AdminBookingAvailabilityDocument, options);
        }
export type AdminBookingAvailabilityQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityQuery>;
export type AdminBookingAvailabilityLazyQueryHookResult = ReturnType<typeof useAdminBookingAvailabilityLazyQuery>;
export type AdminBookingAvailabilityQueryResult = Apollo.QueryResult<AdminBookingAvailabilityQuery, AdminBookingAvailabilityQueryVariables>;
export const AdminBookingDocument = gql`
    query AdminBooking($args: AdminBookingArgs!) {
  adminBooking(args: $args) {
    cancellationDateTime
    cancellationNotificationByAppSent
    cancellationNotificationByEmailSent
    cancellationNotificationBySmsSent
    cancellationNotificationMessage
    cancellationNotificationSentByAdminName
    cancellationNotificationSentDateTime
    cancellationReason
    cancelledBy
    cancelledByAdminName
    coachId
    coachName
    createdAt
    createdBy
    createdByAdminName
    date
    duration
    endTime
    fieldLessonDetails
    gameCourseType
    id
    member
    memberIndividualId
    memberUuid
    noOfPlayers
    resourceName
    startTime
    status
    type
    venue
  }
}
    `;

/**
 * __useAdminBookingQuery__
 *
 * To run a query within a React component, call `useAdminBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
      }
export function useAdminBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingQuery, AdminBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingQuery, AdminBookingQueryVariables>(AdminBookingDocument, options);
        }
export type AdminBookingQueryHookResult = ReturnType<typeof useAdminBookingQuery>;
export type AdminBookingLazyQueryHookResult = ReturnType<typeof useAdminBookingLazyQuery>;
export type AdminBookingQueryResult = Apollo.QueryResult<AdminBookingQuery, AdminBookingQueryVariables>;
export const AdminBookingsDocument = gql`
    query AdminBookings($args: AdminBookingsArgs!) {
  adminBookings(args: $args) {
    edges {
      cursor
      node {
        cancellationDateTime
        date
        endTime
        id
        member {
          firstName
          lastName
        }
        resourceName
        startTime
        status
        type
        venue
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      total
    }
  }
}
    `;

/**
 * __useAdminBookingsQuery__
 *
 * To run a query within a React component, call `useAdminBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminBookingsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAdminBookingsQuery(baseOptions: Apollo.QueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
      }
export function useAdminBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminBookingsQuery, AdminBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminBookingsQuery, AdminBookingsQueryVariables>(AdminBookingsDocument, options);
        }
export type AdminBookingsQueryHookResult = ReturnType<typeof useAdminBookingsQuery>;
export type AdminBookingsLazyQueryHookResult = ReturnType<typeof useAdminBookingsLazyQuery>;
export type AdminBookingsQueryResult = Apollo.QueryResult<AdminBookingsQuery, AdminBookingsQueryVariables>;
export const AdminLoginDocument = gql`
    mutation AdminLogin($input: AdminLoginInput!) {
  adminLogin(input: $input) {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminLoginMutationFn = Apollo.MutationFunction<AdminLoginMutation, AdminLoginMutationVariables>;

/**
 * __useAdminLoginMutation__
 *
 * To run a mutation, you first call `useAdminLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLoginMutation, { data, loading, error }] = useAdminLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminLoginMutation(baseOptions?: Apollo.MutationHookOptions<AdminLoginMutation, AdminLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLoginMutation, AdminLoginMutationVariables>(AdminLoginDocument, options);
      }
export type AdminLoginMutationHookResult = ReturnType<typeof useAdminLoginMutation>;
export type AdminLoginMutationResult = Apollo.MutationResult<AdminLoginMutation>;
export type AdminLoginMutationOptions = Apollo.BaseMutationOptions<AdminLoginMutation, AdminLoginMutationVariables>;
export const AdminLogoutDocument = gql`
    mutation AdminLogout {
  adminLogout
}
    `;
export type AdminLogoutMutationFn = Apollo.MutationFunction<AdminLogoutMutation, AdminLogoutMutationVariables>;

/**
 * __useAdminLogoutMutation__
 *
 * To run a mutation, you first call `useAdminLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminLogoutMutation, { data, loading, error }] = useAdminLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AdminLogoutMutation, AdminLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminLogoutMutation, AdminLogoutMutationVariables>(AdminLogoutDocument, options);
      }
export type AdminLogoutMutationHookResult = ReturnType<typeof useAdminLogoutMutation>;
export type AdminLogoutMutationResult = Apollo.MutationResult<AdminLogoutMutation>;
export type AdminLogoutMutationOptions = Apollo.BaseMutationOptions<AdminLogoutMutation, AdminLogoutMutationVariables>;
export const AdminRefreshAccessTokenDocument = gql`
    mutation AdminRefreshAccessToken {
  adminRefreshAccessToken {
    accessToken
    authenticatedAdmin {
      clubhouseCode
      clubhouses
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastLoginDate
      lastName
      permissions
      profileImageUrl
      ud
      userId
      userType
      yourIp
    }
  }
}
    `;
export type AdminRefreshAccessTokenMutationFn = Apollo.MutationFunction<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;

/**
 * __useAdminRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useAdminRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminRefreshAccessTokenMutation, { data, loading, error }] = useAdminRefreshAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useAdminRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>(AdminRefreshAccessTokenDocument, options);
      }
export type AdminRefreshAccessTokenMutationHookResult = ReturnType<typeof useAdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationResult = Apollo.MutationResult<AdminRefreshAccessTokenMutation>;
export type AdminRefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<AdminRefreshAccessTokenMutation, AdminRefreshAccessTokenMutationVariables>;
export const AdminForgotPasswordDocument = gql`
    mutation AdminForgotPassword($input: AdminForgotPasswordInput!) {
  adminForgotPassword(input: $input) {
    email
    resetToken
  }
}
    `;
export type AdminForgotPasswordMutationFn = Apollo.MutationFunction<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;

/**
 * __useAdminForgotPasswordMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordMutation, { data, loading, error }] = useAdminForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>(AdminForgotPasswordDocument, options);
      }
export type AdminForgotPasswordMutationHookResult = ReturnType<typeof useAdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationResult = Apollo.MutationResult<AdminForgotPasswordMutation>;
export type AdminForgotPasswordMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordMutation, AdminForgotPasswordMutationVariables>;
export const AdminForgotPasswordSubmitDocument = gql`
    mutation AdminForgotPasswordSubmit($input: AdminForgotPasswordSubmitInput!) {
  adminForgotPasswordSubmit(input: $input)
}
    `;
export type AdminForgotPasswordSubmitMutationFn = Apollo.MutationFunction<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;

/**
 * __useAdminForgotPasswordSubmitMutation__
 *
 * To run a mutation, you first call `useAdminForgotPasswordSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminForgotPasswordSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminForgotPasswordSubmitMutation, { data, loading, error }] = useAdminForgotPasswordSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminForgotPasswordSubmitMutation(baseOptions?: Apollo.MutationHookOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>(AdminForgotPasswordSubmitDocument, options);
      }
export type AdminForgotPasswordSubmitMutationHookResult = ReturnType<typeof useAdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationResult = Apollo.MutationResult<AdminForgotPasswordSubmitMutation>;
export type AdminForgotPasswordSubmitMutationOptions = Apollo.BaseMutationOptions<AdminForgotPasswordSubmitMutation, AdminForgotPasswordSubmitMutationVariables>;
export const AdminShopTokensDocument = gql`
    mutation AdminShopTokens($input: AdminShopTokensInput) {
  adminShopTokens(input: $input) {
    expires
    shops
    ud
  }
}
    `;
export type AdminShopTokensMutationFn = Apollo.MutationFunction<AdminShopTokensMutation, AdminShopTokensMutationVariables>;

/**
 * __useAdminShopTokensMutation__
 *
 * To run a mutation, you first call `useAdminShopTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminShopTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminShopTokensMutation, { data, loading, error }] = useAdminShopTokensMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminShopTokensMutation(baseOptions?: Apollo.MutationHookOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminShopTokensMutation, AdminShopTokensMutationVariables>(AdminShopTokensDocument, options);
      }
export type AdminShopTokensMutationHookResult = ReturnType<typeof useAdminShopTokensMutation>;
export type AdminShopTokensMutationResult = Apollo.MutationResult<AdminShopTokensMutation>;
export type AdminShopTokensMutationOptions = Apollo.BaseMutationOptions<AdminShopTokensMutation, AdminShopTokensMutationVariables>;
export const SelfUpdateDocument = gql`
    mutation SelfUpdate($input: SelfUpdateInput!) {
  selfUpdate(input: $input) {
    fileUploadCredentials {
      fields
      signedUrl
    }
    self {
      createdAt
      email
      firstName
      lastLogin {
        city
        ipAddress
        time
      }
      lastName
      logins {
        city
        ipAddress
        time
      }
      mobileNumber
      organizationId
      organizationName
      profileImageUrl
      status
      updatedAt
      userId
      userType
    }
  }
}
    `;
export type SelfUpdateMutationFn = Apollo.MutationFunction<SelfUpdateMutation, SelfUpdateMutationVariables>;

/**
 * __useSelfUpdateMutation__
 *
 * To run a mutation, you first call `useSelfUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdateMutation, { data, loading, error }] = useSelfUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdateMutation, SelfUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdateMutation, SelfUpdateMutationVariables>(SelfUpdateDocument, options);
      }
export type SelfUpdateMutationHookResult = ReturnType<typeof useSelfUpdateMutation>;
export type SelfUpdateMutationResult = Apollo.MutationResult<SelfUpdateMutation>;
export type SelfUpdateMutationOptions = Apollo.BaseMutationOptions<SelfUpdateMutation, SelfUpdateMutationVariables>;
export const SelfUpdatePasswordDocument = gql`
    mutation SelfUpdatePassword($input: SelfUpdatePasswordInput!) {
  selfUpdatePassword(input: $input)
}
    `;
export type SelfUpdatePasswordMutationFn = Apollo.MutationFunction<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;

/**
 * __useSelfUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useSelfUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelfUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selfUpdatePasswordMutation, { data, loading, error }] = useSelfUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelfUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>(SelfUpdatePasswordDocument, options);
      }
export type SelfUpdatePasswordMutationHookResult = ReturnType<typeof useSelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationResult = Apollo.MutationResult<SelfUpdatePasswordMutation>;
export type SelfUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<SelfUpdatePasswordMutation, SelfUpdatePasswordMutationVariables>;
export const SelfDocument = gql`
    query Self {
  self {
    createdAt
    email
    firstName
    lastLogin {
      city
      ipAddress
      time
    }
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organizationId
    organizationName
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useSelfQuery__
 *
 * To run a query within a React component, call `useSelfQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelfQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelfQuery(baseOptions?: Apollo.QueryHookOptions<SelfQuery, SelfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
      }
export function useSelfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelfQuery, SelfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelfQuery, SelfQueryVariables>(SelfDocument, options);
        }
export type SelfQueryHookResult = ReturnType<typeof useSelfQuery>;
export type SelfLazyQueryHookResult = ReturnType<typeof useSelfLazyQuery>;
export type SelfQueryResult = Apollo.QueryResult<SelfQuery, SelfQueryVariables>;
export const LegacyCreateCoachDayAvailabilityDocument = gql`
    mutation LegacyCreateCoachDayAvailability($input: LegacyCreateCoachDayAvailabilityInput!) {
  legacyCreateCoachDayAvailability(input: $input) {
    hasAvailabiliity
  }
}
    `;
export type LegacyCreateCoachDayAvailabilityMutationFn = Apollo.MutationFunction<LegacyCreateCoachDayAvailabilityMutation, LegacyCreateCoachDayAvailabilityMutationVariables>;

/**
 * __useLegacyCreateCoachDayAvailabilityMutation__
 *
 * To run a mutation, you first call `useLegacyCreateCoachDayAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLegacyCreateCoachDayAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [legacyCreateCoachDayAvailabilityMutation, { data, loading, error }] = useLegacyCreateCoachDayAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLegacyCreateCoachDayAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<LegacyCreateCoachDayAvailabilityMutation, LegacyCreateCoachDayAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LegacyCreateCoachDayAvailabilityMutation, LegacyCreateCoachDayAvailabilityMutationVariables>(LegacyCreateCoachDayAvailabilityDocument, options);
      }
export type LegacyCreateCoachDayAvailabilityMutationHookResult = ReturnType<typeof useLegacyCreateCoachDayAvailabilityMutation>;
export type LegacyCreateCoachDayAvailabilityMutationResult = Apollo.MutationResult<LegacyCreateCoachDayAvailabilityMutation>;
export type LegacyCreateCoachDayAvailabilityMutationOptions = Apollo.BaseMutationOptions<LegacyCreateCoachDayAvailabilityMutation, LegacyCreateCoachDayAvailabilityMutationVariables>;
export const LegacyCoachAvailabilitiesDocument = gql`
    query LegacyCoachAvailabilities($userId: String!) {
  legacyCoachAvailabilities(userId: $userId) {
    blockedSlots
    clubhouseCode
    date
    fullyBooked
    hasIndoorBookings
    id
  }
}
    `;

/**
 * __useLegacyCoachAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useLegacyCoachAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyCoachAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyCoachAvailabilitiesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useLegacyCoachAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<LegacyCoachAvailabilitiesQuery, LegacyCoachAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacyCoachAvailabilitiesQuery, LegacyCoachAvailabilitiesQueryVariables>(LegacyCoachAvailabilitiesDocument, options);
      }
export function useLegacyCoachAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacyCoachAvailabilitiesQuery, LegacyCoachAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacyCoachAvailabilitiesQuery, LegacyCoachAvailabilitiesQueryVariables>(LegacyCoachAvailabilitiesDocument, options);
        }
export type LegacyCoachAvailabilitiesQueryHookResult = ReturnType<typeof useLegacyCoachAvailabilitiesQuery>;
export type LegacyCoachAvailabilitiesLazyQueryHookResult = ReturnType<typeof useLegacyCoachAvailabilitiesLazyQuery>;
export type LegacyCoachAvailabilitiesQueryResult = Apollo.QueryResult<LegacyCoachAvailabilitiesQuery, LegacyCoachAvailabilitiesQueryVariables>;
export const LegacySelfAsCoachDocument = gql`
    query LegacySelfAsCoach {
  legacySelfAsCoach {
    bookings {
      coachDisplayName
      coachId
      compFieldLessonToDeduct
      compIndoorLessonToDeduct
      creditToDeduct
      date
      details
      endTime
      id
      location
      member {
        firstName
        id
        individualId
        lastName
        membership {
          id
          membershipId
        }
      }
      profileImageUrl
      resourceName
      slots
      startTime
      status
      type
      userId
      venue
    }
    coachAvailabilities {
      blockedSlots
      clubhouseCode
      date
      fullyBooked
      hasIndoorBookings
      id
    }
    coachBirthdate
    coachBirthPlace
    coachExperiences
    coachExpertise
    coachLanguages
    coachLevel
    coachListOrder
    coachPGANo
    coachPGAType
    coachPGAYear
    coachSavedSlots1
    coachSavedSlots2
    coachSavedSlots3
    createdAt
    displayName
    email
    firstName
    gender
    lastLogin {
      city
      ipAddress
      time
    }
    lastName
    logins {
      city
      ipAddress
      time
    }
    mobileNumber
    organization {
      businessName
      emailDomains
      id
    }
    profileImageUrl
    status
    updatedAt
    userId
    userType
  }
}
    `;

/**
 * __useLegacySelfAsCoachQuery__
 *
 * To run a query within a React component, call `useLegacySelfAsCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacySelfAsCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacySelfAsCoachQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegacySelfAsCoachQuery(baseOptions?: Apollo.QueryHookOptions<LegacySelfAsCoachQuery, LegacySelfAsCoachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacySelfAsCoachQuery, LegacySelfAsCoachQueryVariables>(LegacySelfAsCoachDocument, options);
      }
export function useLegacySelfAsCoachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacySelfAsCoachQuery, LegacySelfAsCoachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacySelfAsCoachQuery, LegacySelfAsCoachQueryVariables>(LegacySelfAsCoachDocument, options);
        }
export type LegacySelfAsCoachQueryHookResult = ReturnType<typeof useLegacySelfAsCoachQuery>;
export type LegacySelfAsCoachLazyQueryHookResult = ReturnType<typeof useLegacySelfAsCoachLazyQuery>;
export type LegacySelfAsCoachQueryResult = Apollo.QueryResult<LegacySelfAsCoachQuery, LegacySelfAsCoachQueryVariables>;
export const LegacyCoachDayBookingsDocument = gql`
    query LegacyCoachDayBookings($input: LegacyCoachDayBookingsInput!) {
  legacyCoachDayBookings(input: $input) {
    bookedSlots
    hasFieldBooking
  }
}
    `;

/**
 * __useLegacyCoachDayBookingsQuery__
 *
 * To run a query within a React component, call `useLegacyCoachDayBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacyCoachDayBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacyCoachDayBookingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLegacyCoachDayBookingsQuery(baseOptions: Apollo.QueryHookOptions<LegacyCoachDayBookingsQuery, LegacyCoachDayBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacyCoachDayBookingsQuery, LegacyCoachDayBookingsQueryVariables>(LegacyCoachDayBookingsDocument, options);
      }
export function useLegacyCoachDayBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacyCoachDayBookingsQuery, LegacyCoachDayBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacyCoachDayBookingsQuery, LegacyCoachDayBookingsQueryVariables>(LegacyCoachDayBookingsDocument, options);
        }
export type LegacyCoachDayBookingsQueryHookResult = ReturnType<typeof useLegacyCoachDayBookingsQuery>;
export type LegacyCoachDayBookingsLazyQueryHookResult = ReturnType<typeof useLegacyCoachDayBookingsLazyQuery>;
export type LegacyCoachDayBookingsQueryResult = Apollo.QueryResult<LegacyCoachDayBookingsQuery, LegacyCoachDayBookingsQueryVariables>;
export const LegacyCreateCoachSavedSlotsDocument = gql`
    mutation LegacyCreateCoachSavedSlots($input: LegacyCreateCoachSavedSlotsInput!) {
  legacyCreateCoachSavedSlots(input: $input)
}
    `;
export type LegacyCreateCoachSavedSlotsMutationFn = Apollo.MutationFunction<LegacyCreateCoachSavedSlotsMutation, LegacyCreateCoachSavedSlotsMutationVariables>;

/**
 * __useLegacyCreateCoachSavedSlotsMutation__
 *
 * To run a mutation, you first call `useLegacyCreateCoachSavedSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLegacyCreateCoachSavedSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [legacyCreateCoachSavedSlotsMutation, { data, loading, error }] = useLegacyCreateCoachSavedSlotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLegacyCreateCoachSavedSlotsMutation(baseOptions?: Apollo.MutationHookOptions<LegacyCreateCoachSavedSlotsMutation, LegacyCreateCoachSavedSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LegacyCreateCoachSavedSlotsMutation, LegacyCreateCoachSavedSlotsMutationVariables>(LegacyCreateCoachSavedSlotsDocument, options);
      }
export type LegacyCreateCoachSavedSlotsMutationHookResult = ReturnType<typeof useLegacyCreateCoachSavedSlotsMutation>;
export type LegacyCreateCoachSavedSlotsMutationResult = Apollo.MutationResult<LegacyCreateCoachSavedSlotsMutation>;
export type LegacyCreateCoachSavedSlotsMutationOptions = Apollo.BaseMutationOptions<LegacyCreateCoachSavedSlotsMutation, LegacyCreateCoachSavedSlotsMutationVariables>;